// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/corazon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/flower.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/corazon-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/corazon-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/images/stick.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/images/japi-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Kanit:wght@800;900&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,400;1,500;1,700;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #fff;
}

.header {
  background-color: #1674d8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: baseline;
}
.header .selb-icon-wrapper {
  font-family: "Kanit", sans-serif;
  color: #fff;
  font-weight: 800;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-evenly;
  gap: 1.5rem;
}
.header .selb-icon-wrapper #refresh-icon {
  width: 30px;
  cursor: pointer;
}
.header .selb-icon-wrapper h4 {
  margin-right: 2rem;
  margin-bottom: 0;
}

.header-japi {
  background-color: #fff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: baseline;
  position: sticky;
}
.header-japi .japi-icon-wrapper {
  font-family: "Kanit", sans-serif;
  color: rgb(56, 163, 165);
  font-weight: 800;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-evenly;
  gap: 1.5rem;
}
.header-japi .japi-icon-wrapper #refresh-icon {
  width: 30px;
  cursor: pointer;
}
.header-japi .japi-icon-wrapper h4 {
  margin-right: 2rem;
  margin-bottom: 0;
}

.aside-bar {
  background-color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: column;
  width: 220px;
  margin-top: 1rem;
  padding: 0.5rem;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 10;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
.aside-bar a {
  text-decoration: none;
  color: #333;
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
  border-radius: 0.8rem;
  -webkit-border-radius: 0.8rem;
  -moz-border-radius: 0.8rem;
  -ms-border-radius: 0.8rem;
  -o-border-radius: 0.8rem;
  cursor: pointer;
}
.aside-bar a:hover {
  background-color: #7ebdc2;
  color: #fff !important;
}
.aside-bar .aside-head {
  display: block;
  width: 80%;
  border-bottom: 1px solid #284b63;
  padding: 1rem 0;
}
.aside-bar .aside-menu {
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  width: 80%;
}

.aside-bar-hidden {
  transform: translate(-100%);
  -webkit-transform: translate(-100%);
  -moz-transform: translate(-100%);
  -ms-transform: translate(-100%);
  -o-transform: translate(-100%);
  transition: 0.5s ease-in;
  -webkit-transition: 0.5s ease-in;
  -moz-transition: 0.5s ease-in;
  -ms-transition: 0.5s ease-in;
  -o-transition: 0.5s ease-in;
}

.aside-bar-active {
  z-index: 9999;
  transform: translate(0%);
  -webkit-transform: translate(0%);
  -moz-transform: translate(0%);
  -ms-transform: translate(0%);
  -o-transform: translate(0%);
  transition: translate 0.5s ease in;
  -webkit-transition: translate 0.5s ease in;
  -moz-transition: translate 0.5s ease in;
  -ms-transition: translate 0.5s ease in;
  -o-transition: translate 0.5s ease in;
}

.active {
  color: #fff;
  font-weight: bold;
}

.profile-picture-wrapper {
  margin-bottom: 1rem;
  overflow: hidden;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  border: 1px solid #ccc;
}
.profile-picture-wrapper img {
  width: 60px;
}

#home-icon, #students-icon, #users-icon, #logout-icon, #excel-icon, #parents-icon, #moment-icon, #development-icon {
  width: 20px;
  margin-bottom: 3px;
  margin-right: 4px;
}

/* .login {
    background-color:rgb(200, 217, 231);
    margin:3rem auto;
    width:50%;
    max-width:600px;
    min-width:250px;
    border-radius:.5rem;
    -webkit-border-radius:.5rem;
    -moz-border-radius:.5rem;
    -ms-border-radius:.5rem;
    -o-border-radius:.5rem;

    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    padding:2rem;

    #loginForm {
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        gap:.5rem;

        img {
            width:50%;
        }

        input {
            width:70%;
            min-width:200px;
            max-width:450px;
            padding:.5rem;
            background-color:#fff;
            border:1px solid #ddd;
            border-radius:.5rem;        ;
            -webkit-border-radius:.5rem        ;
            -moz-border-radius:.5rem        ;
            -ms-border-radius:.5rem        ;
            -o-border-radius:.5rem        ;
}

    }
} */
.signin {
  margin: 0;
  height: 95vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.signin .signin-form {
  border: 1px solid #ccc;
  width: 70%;
  max-width: 1000px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 6rem 2rem;
  background-color: #fff;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.signin .signin-form img {
  width: 50%;
  max-width: 200px;
  margin: 0 auto;
  padding: 0;
  line-height: 0;
}
.signin .signin-form .signin-title {
  color: #fff;
  text-align: center;
}
.signin .signin-form label {
  color: #fff;
}
.signin .signin-form input {
  margin: 0.4rem auto;
  width: 40%;
  min-width: 200px;
  max-width: 400px;
  border: none;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
  background-color: #fff;
  padding: 0.4rem;
}
.signin .signin-form #signin-button {
  display: inline;
  margin: 0 auto;
  padding: 0.4rem;
  width: 100px;
  margin-top: 0.4rem;
}
.signin .signin-form .signin-title {
  color: #444;
}

/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Render the \`main\` element consistently in IE.
 */
main {
  display: block;
}

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input { /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */
legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

.home-wrapper {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.home-wrapper h1 {
  padding: 2rem;
  color: #444;
  text-align: center;
  height: 100%;
}
.home-wrapper h4 {
  color: #444;
}
.home-wrapper .table-wrapper {
  display: flex;
  justify-content: space-evenly;
  align-items: baseline;
  align-content: center;
  flex-wrap: wrap;
}

.table-home {
  width: 300px !important;
  margin: 2rem auto;
  border: 1px solid #444;
  color: #333;
}

.selb-info {
  cursor: pointer;
}

.kid-icon {
  width: 30px;
}

.genre {
  text-align: center;
}

.listed-student {
  background-color: #fff;
  cursor: pointer;
}

.listed-student:hover {
  background-color: #3AAFB9;
  color: #fff;
}

.student-list-wrapper {
  min-width: 300px;
  width: 95%;
  margin: 1rem auto;
  border-radius: 0.4rem;
  -webkit-border-radius: 0.4rem;
  -moz-border-radius: 0.4rem;
  -ms-border-radius: 0.4rem;
  -o-border-radius: 0.4rem;
  border: 1px solid #ccc;
  padding: 1rem;
}
.student-list-wrapper select {
  width: 300px;
  margin: 0 auto;
}

#instruments-list-wrapper {
  width: 100%;
  height: 100vh;
  background: rgba(244, 244, 244, 0.5);
  position: fixed;
  top: 0;
  left: 0;
}
#instruments-list-wrapper #instruments-list {
  position: fixed;
  width: 700px;
  height: 480px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
  background-color: #fff;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0.8rem;
  padding: 1.2rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  align-items: start;
  align-content: flex-start;
  z-index: 20;
}
#instruments-list-wrapper #instruments-list h4 {
  width: 100%;
  text-align: center;
  border-radius: inherit;
  -webkit-border-radius: inherit;
  -moz-border-radius: inherit;
  -ms-border-radius: inherit;
  -o-border-radius: inherit;
  padding: inherit;
  color: #3aafb9;
  font-weight: bold;
  padding: 0;
  margin: 0;
  font-family: "Kanit", sans-serif;
  letter-spacing: 1px;
}
#instruments-list-wrapper #instruments-list .listed-instrument {
  width: 100%;
  cursor: pointer;
  border-radius: 0.4rem;
  font-weight: bold;
  color: #555;
  padding: 0;
}
#instruments-list-wrapper #instruments-list .listed-instrument:hover {
  background-color: #3aafb9;
  color: #fff;
}

.active {
  display: block;
  opacity: 1;
  transition: opacity 1s ease;
  -webkit-transition: opacity 1s ease;
  -moz-transition: opacity 1s ease;
  -ms-transition: opacity 1s ease;
  -o-transition: opacity 1s ease;
}

.hidden {
  display: none;
  opacity: 0;
  transition: opacity 1s ease;
  -webkit-transition: opacity 1s ease;
  -moz-transition: opacity 1s ease;
  -ms-transition: opacity 1s ease;
  -o-transition: opacity 1s ease;
}

#instrument-icon {
  width: 30px;
  margin-bottom: 1px;
  margin-right: 4px;
}

.page-item {
  background-color: #fff;
  height: calc(100vh - 120px);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  text-align: center;
}
.page-item .letter-example {
  width: 80%;
  margin: 0 auto;
}
.page-item .main-description {
  width: 60%;
  line-height: 2rem;
  min-width: 300px;
  margin: 0 auto;
  background-color: transparent;
  padding: 2rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.page-item form {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 2rem;
}
.page-item img {
  max-width: 600px;
}

/* First Instrument */
.instrument-form {
  text-align: start;
  padding: 1rem !important;
}
.instrument-form input, .instrument-form label {
  padding: 0.6rem;
}
.instrument-form label {
  cursor: pointer;
  width: 100%;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.instrument-form label:hover {
  background-color: #3aafb9;
  color: #fff;
}
.instrument-form label > input[type=radio] {
  margin-right: 5px;
}

.sdq-wrapper {
  max-width: 1100px;
  margin: 1rem auto;
  padding: 2rem 0;
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sdq-wrapper .sdq-header {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: inherit;
  padding: 2rem 0;
}
.sdq-wrapper .sdq-header img {
  width: 40%;
}
.sdq-wrapper .sdq-instructions {
  border: 1px solid #ccc;
  width: 90%;
  margin: 0 auto;
}
.sdq-wrapper .sdq-instructions h6 {
  width: 100%;
  background-color: #ccc;
  padding: 0.5rem;
}
.sdq-wrapper .sdq-instructions p {
  padding: 1rem;
}
.sdq-wrapper #sdq-btn {
  width: 150px;
}

.instrument-sdq {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  border: 1px solid #ddd;
  width: 90%;
  margin: 1rem auto;
}
.instrument-sdq .sdq-title {
  width: 40%;
  text-align: start;
}
.instrument-sdq .sdq-option {
  width: 60%;
}
.instrument-sdq .sdq-option label {
  margin-left: 20px;
  padding: 0rem;
}

.instrument-sdq__open {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  width: 90%;
}
.instrument-sdq__open h6 {
  align-self: flex-start;
}
.instrument-sdq__open textarea {
  align-self: flex-start;
  width: 1000px;
  text-align: start;
  padding: 1rem;
  max-height: 200px;
}

.instrument-multiple {
  max-width: 900px;
  margin-bottom: 1rem;
}

.multipleChoicesWrapper {
  border: 1px solid #ddd;
  width: 90%;
  margin: 1rem auto;
}

.instrument-sdq__extended {
  display: flex;
  border: 1px solid #ddd;
  margin: 1rem auto;
  width: 90%;
  flex-direction: column;
}
.instrument-sdq__extended .sdq-option {
  text-align: center;
}

.aces-item {
  width: 100px !important;
  height: 100px !important;
}

.book-wrapper {
  width: 98%;
  margin-left: 1rem;
  margin-right: 1rem;
  padding: 1rem;
  box-shadow: 0px 1px 2px rgb(0, 0, 0);
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  background-color: #CED4AC;
}
.book-wrapper .demopage {
  width: 100%;
  border-radius: inherit;
  -webkit-border-radius: inherit;
  -moz-border-radius: inherit;
  -ms-border-radius: inherit;
  -o-border-radius: inherit;
}
.book-wrapper .stf__block {
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.8);
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.book-wrapper img {
  max-width: 100%;
}

.instruction {
  background-color: #3AAFB9;
  color: #fff;
  padding: 2rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}

.statement {
  color: #444;
  padding: 2rem;
}

.statement-instruction {
  font-size: 3.5rem;
}

.excel-container {
  display: flex;
  flex-direction: column;
  width: 800px;
  margin: 2rem auto;
  gap: 0.5rem;
}
.excel-container h2 {
  text-align: center;
  padding: 2rem 0;
}
.excel-container #btn-excel {
  width: 150px;
  margin: 1rem auto;
  text-align: center;
}

.sdq-form-container {
  display: flex;
  flex-direction: column;
  width: 800px;
  margin: 2rem auto;
  gap: 0.5rem;
}
.sdq-form-container h2 {
  text-align: center;
  padding: 2rem 0;
}
.sdq-form-container .btn-parent {
  width: 150px;
  margin: 1rem auto;
  text-align: center;
}

.aces-test {
  height: 100%;
  overflow: hidden;
}

.aces-direction {
  display: flex;
  flex-direction: column !important;
  transform: rotate(270deg) !important;
  flex-wrap: nowrap;
  width: 100%;
}
.aces-direction img {
  width: 450px;
}

* {
  box-sizing: border-box;
}

.aces-page-item {
  max-width: 100%;
  margin-left: 0;
}

.next {
  width: 200px;
}

.aces-next {
  max-width: 100%;
  overflow: hidden;
}
.aces-next p {
  max-width: 1100px;
}

.aces-content-wrapper {
  width: 600px;
  flex-direction: column !important;
}

#root > div.aces-test > div > div.swiper-button-prev {
  padding: 0px;
  width: 40px !important;
  height: 40px !important;
}

#root > div.aces-test > div > div.swiper-button-next {
  padding: 0 !important;
  width: 40px !important;
  height: 40px !important;
}

.swiper-button-next:after, .swiper-button-prev:after {
  font-size: 1rem !important;
  padding: 0;
  margin: 0;
}

.wally-emotion {
  max-width: 170px !important;
}

.eml-emotion {
  max-width: 170px !important;
}

#swiper-wrapper-47465d4421825ce4 > div.swiper-slide.swiper-slide-active > div > img {
  max-width: 450px;
}

.item-image-wally {
  text-align: center;
  margin: 4rem auto 0 auto;
  width: 900px;
}
.item-image-wally img {
  width: 80%;
  max-width: 600px;
  margin: 1rem;
}

.wally-action {
  max-width: 230px !important;
}

.wally-label {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.wally-label p {
  text-align: center;
  font-weight: 700;
}

.wally-form {
  display: flex;
  flex-direction: row !important;
  /*     gap:2rem; */
}

.item-image-eml {
  text-align: center;
  margin: 4rem auto 0 auto;
  width: 900px;
}
.item-image-eml img {
  width: 80%;
  max-width: 600px;
  margin: 1rem;
}

.eml-action {
  max-width: 230px !important;
}

.eml-label {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.eml-label p {
  text-align: center;
  font-weight: 700;
}

.eml-form {
  display: flex;
  flex-direction: row !important;
  /*     gap:2rem; */
}

.corsi-container {
  background-color: #333;
  height: calc(100% - 60px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.corsi-container .separator {
  position: absolute;
  width: 100%;
  height: calc(100% - 60px);
}
.corsi-container .game-box {
  width: 1000px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 2rem;
  padding-top: 4rem;
}
.corsi-container .game-box .corsi-box {
  border: 1px solid #fff;
  width: 90px;
  height: 90px;
}
.corsi-container .game-box .box-1 {
  margin-left: 2rem;
  margin-top: 8rem;
}
.corsi-container .game-box .box-2 {
  margin-left: 2rem;
}
.corsi-container .game-box .box-3 {
  margin-left: 4rem;
  margin-top: 5rem;
}
.corsi-container .game-box .box-4 {
  margin-left: 5rem;
  margin-top: 7rem;
}
.corsi-container .game-box .box-5 {
  margin-left: 5rem;
  margin-top: 2rem;
}
.corsi-container .game-box .box-6 {
  margin-left: 4rem;
}
.corsi-container .game-box .box-7 {
  margin-left: 4rem;
  margin-top: -4rem;
}
.corsi-container .game-box .box-8 {
  margin-left: 4rem;
  margin-top: -2rem;
}
.corsi-container .game-box .box-9 {
  margin-left: 4rem;
  margin-top: 3rem;
}
.corsi-container .game-box .box-10 {
  margin-left: 4rem;
  margin-top: -6rem;
}
@media (min-width: 1200px) {
  .corsi-container .game-box {
    gap: 2.5rem;
  }
}

.switch-on {
  border: 1px solid #4897be !important;
  background-color: #4897be;
}

.hidden {
  display: none;
  visibility: hidden;
}

.corsi-options {
  border: 1px solid #ccc;
  align-self: center;
}

.corsi-start,
.rotate-container {
  transform: rotate(270deg);
}

.table-moments {
  width: 60% !important;
  margin: 0 auto;
}
.table-moments h2 {
  padding: 2rem 0;
}

.hnf-container {
    display: flex;
    flex-direction: column;
  }
  .hnf-container .hnf-option-container {
    display: flex;
    border: 1px solid #ccc;
    justify-content: space-between;
    border-radius: 0.5rem;
    margin: 2rem;
    position: relative !important;
  }
  .hnf-container .hnf-box {
    width: 50%;
    height: 200px;
    border-radius: 0.5rem;
    background-color: #fff;
    z-index: 2;
  }
  .hnf-container .hnf-button-container {
    display: flex;
    justify-content: space-around;
    border-radius: 0.5rem;
  }
  .hnf-container .hnf-button-container .hnf-button {
    width: 400px;
    height: 250px;
    border-radius: 0.5rem;
    border: none;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.4);
    background-color: #f3f3f7;
  }
  .hnf-container .hnf-button-container .hnf-button:active {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  }
  
  .hnf-heart {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .hnf-flower {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 10px;
  }
  
  .hnf-instructions-1 {
    position: absolute;
    width: 100%;
    height: 600px;
    z-index: 10;
    background-color: #fff;
  }
  .hnf-instructions-1 div h4 {
    width: 80%;
    margin: 2rem auto;
    text-align: center;
  }

.plusOverlay {
  background-color: #fff;
  width: 300px !important;
}

.first-example {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 400px;
  height: 250px;
}

.second-example {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 400px;
  height: 250px;
}

.hnf-example-container {
  display: flex;
  justify-content: space-around;
  margin-top: 3rem;
}

.hidden-container {
  z-index: 0;
  display: none;
  visibility: hidden;
}

#hnf-wall {
  border: 2px solid red;
  z-index: -1;
  background-color: #ddd;
}

.overlay {
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.5);
}

.container-hnf {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.play-button {
  cursor: pointer;
}

.active-option {
  color: #fff;
  background-color: #20c997;
}

.go-btn {
  display: flex;
  width: 90%;
  margin: 0 auto;
  margin-top: 14rem;
  justify-content: center;
}

@media (max-height: 650px) {
  p {
    font-size: 0.95rem;
  }
  h2 {
    font-size: 1.5rem !important;
  }
  .main-description {
    font-size: 1.2rem;
    padding: 0 !important;
  }
  #root .aside-menu a {
    padding: 0;
  }
  .instruments-list div {
    padding: 0;
  }
  .page-item img {
    max-width: 500px;
  }
  .containerBox {
    height: 300px !important;
    width: 600px !important;
  }
  .containerBox > .landing-area > .piece-inside,
  .containerBox > .landing-area > .piece-inside-countable,
  .containerBox > .pieces-container > .piece {
    width: 50px !important;
    height: 50px !important;
  }
  .play-button {
    width: 50px;
    height: 50px;
  }
  .play-button img {
    width: 50px !important;
  }
  .go-btn {
    margin-top: 5.5rem;
    margin-left: -12rem;
  }
  .title-answers {
    font-size: 1rem;
  }
  .item-image-wally img {
    max-width: 420px;
  }
  .item-image-eml img {
    max-width: 420px;
  }
  .aces-page-item img {
    width: 400px;
  }
  .column-instruction .instruction {
    height: 350px;
    width: 350px;
    margin: -3rem;
  }
  .column-instruction .instruction p {
    font-size: 1rem;
  }
  .corsi-container {
    padding-top: 2rem;
  }
  .corsi-container .game-box {
    padding: 1rem;
    padding-top: 0;
    gap: 2.5rem;
  }
  .hnf-button-container .hnf-button {
    width: 350px !important;
    height: 200px !important;
    border-radius: 0.5rem;
    border: none;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.4);
    background-color: #f3f3f7;
  }
}
.thirdStick {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 30px 300px;
}

.secondStick {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 30px 210px;
}

.firstStick {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 30px 120px;
}

.esc-image {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 600px; /* Need a specific value to work */
}

.esc-emotion {
  width: 350px;
  height: 200px;
  box-sizing: border-box;
}

.esc-test {
  display: flex;
  flex-direction: column;
}

.esc-test:hover {
  outline: 4px solid #3aafb9;
}

.esc-test:active {
  outline: 4px solid #3aafb9;
}

.esc-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.esc-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-start;
}

@media (min-width: 1200px) {
  .esc-emotion {
    width: 500px;
    height: 250px;
    box-sizing: border-box;
  }
}
html {
  background-color: #fff;
}

.first-instrument {
  height: 100%;
}

body, html {
  -webkit-touch-callout: none; /* Safari */
  -webkit-user-select: none; /* Chrome */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

img {
  pointer-events: none;
}

#root {
  background-color: #fff;
  height: 100vh;
}

.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before {
  background-color: #fff !important;
}

.swiper {
  height: 100%;
  overflow: hidden;
}

.swiper-button-disabled {
  visibility: hidden !important;
}

.swiper-button-next,
.swiper-button-prev {
  background-color: #3aafb9;
  color: #fff !important;
  width: 45px !important;
  margin-top: 30vh !important;
  padding: 1rem;
  border-radius: 2rem;
  -webkit-border-radius: 2rem;
  -moz-border-radius: 2rem;
  -ms-border-radius: 2rem;
  -o-border-radius: 2rem;
  box-shadow: 0px 5px 5px rgba(2, 2, 0, 0.35);
}

.swiper-button-next:active,
.swiper-button-prev:active {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}

.swiper-button-next {
  margin-right: 3rem;
}

.swiper-button-prev {
  margin-left: 3rem;
}

.swiper-scrollbar-drag {
  background-color: #ff6838 !important;
}

/* Se supone esto ayuda para no recargar la pagina en celulares desplazando el dedo */
body {
  overscroll-behavior-y: contain !important;
}

.button {
  width: 120px;
  margin: 0 auto;
}

.game-title {
  text-align: center;
  margin-top: 0.7rem;
  color: #444;
}

.containerBox {
  margin: 2rem;
  width: 800px;
  height: 500px;
  margin: 2rem auto;
  display: flex;
  justify-content: center;
}
.containerBox .pieces-container {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  gap: 0.5rem;
  padding: 0.2rem;
}
.containerBox .pieces-container .piece {
  width: 70px;
  height: 70px;
  background-color: #FF5656;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
}
.containerBox .landing-area {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  gap: 0.5rem;
  padding: 0.2rem;
  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.6);
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.containerBox .landing-area .piece-inside, .containerBox .landing-area .piece-inside-countable {
  width: 70px;
  height: 70px;
  background-color: #FF5656;
  border-radius: 50%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}

.restart-button {
  display: block;
  width: 100px;
  height: 40px;
  color: #fff;
  background-color: #3aafb9;
  text-align: center;
  margin: 0 auto;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  border: none;
  outline: none !important;
}

.quantification-value {
  width: 70px;
  padding: 0.5rem !important;
}

.swiper-scrollbar {
  height: 1rem !important;
}

.swiper-wrapper {
  height: calc(100vh - 120px) !important;
}

.btn-visibility {
  width: 40px;
  height: 40px;
  outline: none;
  border: none;
  display: inline;
  position: absolute;
  top: -10px;
  right: 10px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  box-shadow: 0px 3px 3px rgba(2, 2, 0, 0.25);
  background-color: inherit;
  color: #3aafb9;
}

.image-instruction-container {
  width: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  position: relative;
}

.main-content-wrapper {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  align-content: center;
  gap: 2rem;
}
.main-content-wrapper img {
  max-width: 100%;
  max-height: 500px;
}
.main-content-wrapper form {
  width: 50%;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.quantification-counter {
  display: flex;
  align-items: baseline;
  align-content: center;
  justify-content: space-between;
  width: 400px;
  gap: 0.5rem;
}
.quantification-counter .form-check-label {
  padding: 0;
  margin: 0 1rem;
  width: 70px !important;
}

.japi-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  padding: 2rem;
  display: flex;
  align-items: center;
  height: 100%;
  gap: 10px;
  flex-direction: column;
}

.japi-container-center {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  padding: 2rem;
  display: flex;
  align-items: center;
  height: 100%;
  gap: 10px;
  flex-direction: column;
  justify-content: center;
}



  
/* --------------------------------------- STROOP NUMÉRICO --------------------------------------- */
.stroopnum-black-section {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    font-family: "Times New Roman", Times, serif;
    display: flex;
    justify-content: center;
    align-items: center;
}

.stroopnum-cross-container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1%;
    height: 100px;
    transform: translate(-50%, -45%);
    z-index: 1; /* Asegúrate de que la cruz esté delante del contenido */
}

.stroopnum-cross {
    position: absolute;
    background-color: white;
}

.stroopnum-horizontal {
    width: 100%;
    height: 3px;
    top: 50%;
    transform: translateY(-50%);
}

.stroopnum-vertical {
    width: 3px;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
}

/* Contenedor principal */
.stroopnum-container {
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* Texto central */
.stroopnum-central-text {
    color: white;
    font-size: 50px;
    margin-bottom: 100px;
}

/* Estilos generales para los botones */
.stroopnum-button-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2 columnas iguales */
    grid-template-rows: repeat(2, 1fr); /* 2 filas iguales */
    gap: 10px; /* Espacio entre los botones */
    width: 300px; /* Ancho fijo para las grillas */
    height: 300px; /* Alto fijo para las grillas */
}

/* Grilla inferior izquierda */
.stroopnum-button-grid-left {
    position: absolute;
    bottom: 20px; /* Ajusta según sea necesario */
    left: 100px; /* Ajusta según sea necesario */
}

/* Grilla inferior derecha */
.stroopnum-button-grid-right {
    position: absolute;
    bottom: 20px; /* Ajusta según sea necesario */
    right: 60px; /* Ajusta según sea necesario */
}

/* Botones redondos */
.stroopnum-no-button {
    background-color: black;
    color: black;
    border: none;
    width: 100px;
    height: 100px;
}

/* Botones redondos */
.stroopnum-round-button {
    background-color: white;
    color: black;
    border: none;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    font-size: 36px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.stroopnum-round-button.highlight{
    border-color: blue;
    background-color: #fffc61;
}

/* --------------------------------------- STROOP COLOR --------------------------------------- */
.stroopcol-black-section {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    font-family: "Times New Roman", Times, serif;
    display: flex;
    justify-content: center;
    align-items: center;
}

.stroopcol-cross-container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100px;
    height: 100px;
    transform: translate(-50%, -45%);
    z-index: 1; /* Asegúrate de que la cruz esté delante del contenido */
}

.stroopcol-cross {
    position: absolute;
    background-color: white;
}

.stroopcol-horizontal {
    width: 100%;
    height: 3px;
    top: 50%;
    transform: translateY(-50%);
}

.stroopcol-vertical {
    width: 3px;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
}

/* Contenedor principal */
.stroopcol-container {
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* Texto central */
.stroopcol-central-text {
    color: white;
    font-size: 50px;
    margin-bottom: 100px;
}

/* Estilos generales para los botones */
.stroopcol-button-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2 columnas iguales */
    grid-template-rows: repeat(2, 1fr); /* 2 filas iguales */
    gap: 10px; /* Espacio entre los botones */
    width: 300px; /* Ancho fijo para las grillas */
    height: 300px; /* Alto fijo para las grillas */
}

/* Grilla inferior izquierda */
.stroopcol-button-grid-left {
    position: absolute;
    bottom: 30px; /* Ajusta según sea necesario */
    left: 100px; /* Ajusta según sea necesario */
}

/* Grilla inferior derecha */
.stroopcol-button-grid-right {
    position: absolute;
    bottom: 30px; /* Ajusta según sea necesario */
    right: 70px; /* Ajusta según sea necesario */
}

/* Botones redondos */
.stroopcol-no-button {
    background-color: black;
    color: black;
    border: none;
    width: 100px;
    height: 100px;
}

/* Botones redondos */
.stroopcol-round-button {
    background-color: white;
    color: black;
    border: 8px solid;
    border-color: black;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.stroopcol-round-button.highlight{
    border-color: white;
}

/* --------------------------------------- CMASR --------------------------------------- */

/* Contenedor principal */
.cmasr-container {
    display: flex;
    flex-direction: column; /* Organiza los elementos verticalmente */
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #ffffff;
    padding: 20px;
}

/* Contenedor de botones */
.cmasr-button-container {
    width: 60%;
    display: flex;
    justify-content: space-around;
    position: absolute;
    bottom: 140px;
}

/* Contenedor de la imagen */
.cmasr-image-container {
    position: center;
    transform: translate(0%, -40%); /* Centra la imagen */
}

/* Imagen centrada */
.cmasr-center-image {
    width: 350px; /* Ajusta el tamaño de la imagen según sea necesario */
    height: auto; /* Mantiene la proporción de la imagen */
}

/* Texto central en un rectángulo redondeado */
.cmasr-central-text {
    color: rgb(0, 0, 0);
    font-family: "Times New Roman", Times, serif;
    font-size: 28px;
    margin-bottom: 150px;
    background-color: #ffffff; /* Fondo blanco para el rectángulo */
    padding-top: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */
    padding-bottom: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */
    padding-left: 100px;
    padding-right: 100px;
    border-radius: 12px; /* Grado de redondeo de las esquinas */
    border: 2.25px solid #000000; /* Borde negro de 2px */
    text-align: center; /* Centra el texto dentro del rectángulo */
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Sombra para darle un efecto de elevación */
}


/* Botones redondeados */
.cmasr-round-button {
    display: inline-block;
    padding: 10px 20px;
    background-color: #ffffff; /* Fondo blanco para el rectángulo */
    font-family: "Times New Roman", Times, serif;
    border-style: solid;
    border-width: 2.25px;
    border-radius: 8px;
    text-align: center;
    text-decoration: none;
    font-size: 28px;
    cursor: pointer;
    width: 150px; /* Ancho fijo del botón */
    height: 100px; /* Alto fijo del botón */
    border-color: #000000; /* Color de borde predeterminado */
    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */
    color: #000; /* Color del texto predeterminado */
}

/* Estilo del botón activo (al presionar) */
.cmasr-round-button.active {
    border-color: blue; /* Color del borde cuando el botón está activo */
    background-color: #ffffff; /* Fondo ligeramente gris para indicar presión */
}

.cmasr-round-button.highlight {
    border-color: blue; /* Color del borde cuando el botón está activo */
    background-color: #fffc61; /* Fondo ligeramente gris para indicar presión */
}


/* Botón redondo con imagen */
.cmasr-top-right-button {
    position: absolute;
    top: 90px;
    right: 30px;
    width: 90px;
    height: 90px;
    border-radius: 50%; /* Redondear el botón */
    background-color: #bfbfbf; /* Color de fondo del botón */
    border-width: 4px;
    border-color: #bfbfbf;
    border-style: solid;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.cmasr-top-right-button.highlight {
    border-color: blue; /* Color del borde cuando el botón está activo */
    background-color: #fffc61; /* Fondo ligeramente gris para indicar presión */
}

.cmasr-top-right-button img {
    width: 40px; /* Ajusta el tamaño de la imagen */
    height: 40px;
}

.cmasr-bottom-right-button {
    display: inline; /* Utiliza flexbox para alinear imagen y texto */
    align-items: center; /* Centra verticalmente la imagen y el texto */
    padding: 10px 0px; /* Espaciado interno del botón */
    border-radius: 20px; /* Bordes redondeados */
    border-style: solid;
    border-width: 3px;
    border-color: #ffffff; /* Bordes redondeados */
    background-color: #ffffff; /* Color de fondo */
    cursor: pointer; /* Cursor en forma de mano al pasar sobre el botón */
    position: absolute;
    bottom: 15px;
    right: 0px;
}

.cmasr-bottom-right-button.highlight {
    border-color: blue;
    background-color: #fffc61;
}

.cmasr-arrow {
    width: 70%;
    height: auto;
    object-fit: cover;
}

.cmasr-button-text {
    position: absolute; /* Posiciona el texto en relación al botón */
    top: 50%; /* Centra verticalmente el texto */
    left: 60%; /* Centra horizontalmente el texto */
    transform: translate(-80%, -50%); /* Ajusta la posición para centrar completamente */
    color: rgb(0, 0, 0); /* Color del texto */
    font-size: 20px; /* Tamaño de la fuente */
    font-weight: bold; /* Negrita */
    pointer-events: none; /* Evita que el texto interfiera con el clic en el botón */
}

/* --------------------------------------- AUTOCONCEPTO --------------------------------------- */

/* Contenedor principal */
.autocon-container {
    display: flex;
    flex-direction: column; /* Organiza los elementos verticalmente */
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #ffffff;
    padding: 20px;
}

/* Contenedor de botones */
.autocon-button-container {
    width: 70%;
    display: flex;
    justify-content: space-around;
    position: absolute;
    bottom: 200px;
}

/* Contenedor de la imagen */
.autocon-image-container {
    position: center;
    transform: translate(0%, -40%); /* Centra la imagen */
}

/* Imagen centrada */
.autocon-center-image {
    width: 350px; /* Ajusta el tamaño de la imagen según sea necesario */
    height: auto; /* Mantiene la proporción de la imagen */
}

/* Texto central en un rectángulo redondeado */
.autocon-central-text {
    color: rgb(0, 0, 0);
    font-family: "Times New Roman", Times, serif;
    font-size: 28px;
    margin-bottom: 230px;
    background-color: #ffffff; /* Fondo blanco para el rectángulo */
    padding-top: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */
    padding-bottom: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */
    padding-left: 100px;
    padding-right: 100px;
    border-radius: 12px; /* Grado de redondeo de las esquinas */
    border: 2.25px solid #000000; /* Borde negro de 2px */
    text-align: center; /* Centra el texto dentro del rectángulo */
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Sombra para darle un efecto de elevación */
}


/* Botones redondeados */
.autocon-round-button {
    display: flex; /* Cambiado de inline-block a flex */
    flex-direction: column; /* Asegura que el contenido esté en columna */
    justify-content: center; /* Centra verticalmente el contenido */
    align-items: center; /* Centra horizontalmente el contenido */
    padding: 10px 20px;
    background-color: #ffffff; /* Fondo blanco para el rectángulo */
    font-family: "Times New Roman", Times, serif;
    border-style: solid;
    border-width: 2.25px;
    border-radius: 15px;
    text-align: center;
    text-decoration: none;
    font-size: 28px;
    cursor: pointer;
    width: 170px; /* Ancho fijo del botón */
    height: 100px; /* Alto fijo del botón */
    border-color: #000000; /* Color de borde predeterminado */
    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */
    color: #000; /* Color del texto predeterminado */
}

/* Estilo del texto en negrita */
.autocon-round-button .text-bold {
    font-weight: bold;
    font-size: 24px;
}

/* Estilo del texto normal */
.autocon-round-button .text-normal {
    font-weight: normal;
    font-size: 18px;
    line-height: 1;
}

.autocon-round-button.highlight {
    border-color: blue;
    background-color: #fffc61;
}

/* Estilo del botón activo (al presionar) */
.autocon-round-button.active {
    border-color: blue; /* Color del borde cuando el botón está activo */
    background-color: #ffffff; /* Fondo ligeramente gris para indicar presión */
}

.autocon-bottom-right-button {
    display: inline; /* Utiliza flexbox para alinear imagen y texto */
    align-items: center; /* Centra verticalmente la imagen y el texto */
    padding: 10px 0px; /* Espaciado interno del botón */
    border-radius: 20px; /* Bordes redondeados */
    border-style: solid;
    border-width: 3px;
    border-color: #ffffff; /* Bordes redondeados */
    background-color: #ffffff; /* Color de fondo */
    cursor: pointer; /* Cursor en forma de mano al pasar sobre el botón */
    position: absolute;
    bottom: 15px;
    right: 0px;
}

.autocon-bottom-right-button.highlight {
    border-color: blue;
    background-color: #fffc61;
}

.autocon-arrow {
    width: 70%;
    height: auto;
    object-fit: cover;
}

.autocon-button-text {
    position: absolute; /* Posiciona el texto en relación al botón */
    top: 50%; /* Centra verticalmente el texto */
    left: 60%; /* Centra horizontalmente el texto */
    transform: translate(-80%, -50%); /* Ajusta la posición para centrar completamente */
    color: rgb(0, 0, 0); /* Color del texto */
    font-size: 20px; /* Tamaño de la fuente */
    font-weight: bold; /* Negrita */
    pointer-events: none; /* Evita que el texto interfiera con el clic en el botón */
}

/* --------------------------------------- ACT.MAT --------------------------------------- */

/* Contenedor principal */
.actmat-container {
    display: flex;
    flex-direction: column; /* Organiza los elementos verticalmente */
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #ffffff;
    padding: 20px;
}

/* Contenedor de botones */
.actmat-button-container {
    width: 60%;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 200px;
}

/* Contenedor de la imagen */
.actmat-image-container {
    position: center;
    transform: translate(0%, -40%); /* Centra la imagen */
}

/* Imagen centrada */
.actmat-center-image {
    width: 350px; /* Ajusta el tamaño de la imagen según sea necesario */
    height: auto; /* Mantiene la proporción de la imagen */
}

/* Texto central en un rectángulo redondeado */
.actmat-central-text {
    color: rgb(0, 0, 0);
    font-family: "Times New Roman", Times, serif;
    font-size: 40px;
    margin-bottom: 230px;
    background-color: #ffffff; /* Fondo blanco para el rectángulo */
    padding-top: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */
    padding-bottom: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */
    padding-left: 100px;
    padding-right: 100px;
    text-align: center; /* Centra el texto dentro del rectángulo */
}

.actmat-label {
    display: flex; /* Cambiado de inline-block a flex */
    flex-direction: column; /* Asegura que el contenido esté en columna */
    justify-content: center; /* Centra verticalmente el contenido */
    align-items: center; /* Centra horizontalmente el contenido */
    padding: 10px 20px;
    background-color: #ffffff; /* Fondo blanco para el rectángulo */
    font-family: "Times New Roman", Times, serif;
    border-width: 0px;
    text-align: center;
    text-decoration: none;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    width: auto; /* Ancho fijo del botón */
    height: auto; /* Alto fijo del botón */
    border-color: #000000; /* Color de borde predeterminado */
    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */
    color: #000; /* Color del texto predeterminado */
}

/* Botones */
.actmat-button {
    display: flex; /* Cambiado de inline-block a flex */
    flex-direction: column; /* Asegura que el contenido esté en columna */
    justify-content: center; /* Centra verticalmente el contenido */
    align-items: center; /* Centra horizontalmente el contenido */
    padding: 0px 40px;
    background-color: #ffffff; /* Fondo blanco para el rectángulo */
    font-family: "Times New Roman", Times, serif;
    border-style: solid;
    border-width: 3px 1.5px;
    text-align: center;
    text-decoration: none;
    font-size: 28px;
    cursor: pointer;
    width: auto; /* Ancho fijo del botón */
    height: auto; /* Alto fijo del botón */
    border-color: #000000; /* Color de borde predeterminado */
    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */
    color: #000; /* Color del texto predeterminado */
}

.actmat-button.highlight {
    border-color: blue;
    background-color: #fffc61;
}

/* Estilo del botón activo (al presionar) */
.actmat-button.active {
    border-color: blue; /* Color del borde cuando el botón está activo */
    background-color: #ffffff; /* Fondo ligeramente gris para indicar presión */
}

.actmat-bottom-right-button {
    display: inline; /* Utiliza flexbox para alinear imagen y texto */
    align-items: center; /* Centra verticalmente la imagen y el texto */
    padding: 10px 0px; /* Espaciado interno del botón */
    border-radius: 20px; /* Bordes redondeados */
    border-style: solid;
    border-width: 3px;
    border-color: #ffffff; /* Bordes redondeados */
    background-color: #ffffff; /* Color de fondo */
    cursor: pointer; /* Cursor en forma de mano al pasar sobre el botón */
    position: absolute;
    bottom: 15px;
    right: 0px;
}

.actmat-bottom-right-button.highlight {
    border-color: blue;
    background-color: #fffc61;
}

.actmat-arrow {
    width: 70%;
    height: auto;
    object-fit: cover;
}

.actmat-button-text {
    position: absolute; /* Posiciona el texto en relación al botón */
    top: 50%; /* Centra verticalmente el texto */
    left: 60%; /* Centra horizontalmente el texto */
    transform: translate(-80%, -50%); /* Ajusta la posición para centrar completamente */
    color: rgb(0, 0, 0); /* Color del texto */
    font-size: 20px; /* Tamaño de la fuente */
    font-weight: bold; /* Negrita */
    pointer-events: none; /* Evita que el texto interfiera con el clic en el botón */
}

/* --------------------------------------- LISTENING SPAN --------------------------------------- */
.listspan-black-section {
    margin: 0;
    padding: 0;
    height: 100vh; /* Utiliza toda la altura de la ventana */
    width: 100vw; /* Utiliza toda la anchura de la ventana */
    background-color: black;
    font-family: "Times New Roman", Times, serif;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra verticalmente el contenido */
    align-items: center; /* Centra horizontalmente el contenido */
    overflow: hidden; /* Evita barras de desplazamiento */
}

/* Contenedor principal */
.listspan-container {
    text-align: center;
    width: 100%; /* Ajustado al 100% para ocupar el espacio completo */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.listspan-text-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* El contenedor ocupará toda la pantalla */
    width: 100vw;  /* El ancho del contenedor será el 100% de la pantalla */
    text-align: center;
}

.listspan-central-text {
    color: rgb(255, 255, 255);
    font-family: "Times New Roman", Times, serif;
    font-size: 50px;
    background-color: transparent;
    text-align: center;
}

/* Ajustar el contenedor de la imagen para centrarlo correctamente */
.listspan-image-container {
    padding-top: 1rem; /* Ajusta el espacio superior */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

/* Ajustar el tamaño de la imagen */
.listspan-center-image {
    width: 100px;
    height: auto;
    max-width: 100%;
}

/* Botones debajo de la imagen */
.listspan-buttons-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    width: 100%;
}

/* Estilos de los botones */
.listspan-button {
    padding: 10px 20px;
    margin: 0 6%; /* Ajusta el espacio entre los botones */
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    font-size: 32px;
    font-weight: bold;
    width: 200px;
    height: 75px;
}

/* Estilo para la grilla de botones */
.listspan-grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 3 columnas para un total de 12 botones */
    grid-gap: 20px 70px; /* Espacio entre los elementos de la grilla */
}

/* Estilo para cada ítem de la grilla */
.listspan-grid-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.listspan-grid-button {
    font-size: 20px;
    width: 70px;
    height: 36px;
    font-weight: bold;
}

.listspan-grid-button:disabled {
    background-color: white;
    color: black;
}

.listspan-grid-text {
    color: white;
    font-size: 28px;
}

/* Texto debajo de la grilla */
.listspan-info-text {
    font-size: 28px;
    font-weight: bold;
    color: white; /* Ajusta el color según tu diseño */
    margin: 40px;
    height: 30px;
}

/* Botones adicionales debajo del texto */
.listspan-additional-buttons {
    display: flex;
    gap: 60px; /* Espacio entre los botones */
    margin-bottom: 60px;
}

.listspan-additional-button {
    padding: 10px 20px;
    font-size: 20px;
    width: 120px;
    cursor: pointer;
    border-radius: 50px;
}

/* --------------------------------------- COUNTING SPAN --------------------------------------- */
/* Contenedor principal */
.countspan-centered-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Asegura que el contenedor ocupe toda la pantalla */
}

/* Contenedor de la imagen */
.countspan-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 650px; /* Limita el ancho máximo de la imagen */
    margin-bottom: 10px;
}

/* Imagen que se adapta a la pantalla */
.countspan-image {
    max-width: 100%; /* La imagen no excede el ancho del contenedor */
    height: auto; /* Mantiene las proporciones de la imagen */
    max-height: 80vh; /* Asegura que la imagen no sea demasiado alta */
}

/* Contenedor de los botones */
.countspan-button-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* Fila de botones */
.countspan-button-row {
    display: flex;
    justify-content: center;
}

/* Botones numerados */
.countspan-number-button {
    padding: 10px 20px;
    margin: 5px;
    background-color: #fff;
    border: 1px solid #000000;
    border-radius: 5px;
    font-size: 26px;
    font-family: 'Times New Roman';
    cursor: pointer;
    width: 60px;
    height: 60px;
}

/* Estilo del botón activo (al presionar) */
.countspan-number-button.active {
    border: 2px solid blue; /* Color del borde cuando el botón está activo */
    background-color: #eca649; /* Fondo ligeramente gris para indicar presión */
    color: black;
    font-weight: bold;
}


.countspan-number-button:disabled {
    /* background-color: white; */
    color: black;
}`, "",{"version":3,"sources":["webpack://./src/scss/_index.scss","webpack://./src/css/styles.css","webpack://./src/scss/_navbar.scss","webpack://./src/scss/_aside.scss","webpack://./src/scss/_login.scss","webpack://./src/scss/_normalize.scss","webpack://./src/scss/_home.scss","webpack://./src/scss/_students.scss","webpack://./src/scss/_instruments-list.scss","webpack://./src/scss/_items.scss","webpack://./src/scss/_book.scss","webpack://./src/scss/_instruction.scss","webpack://./src/scss/_excel.scss","webpack://./src/scss/_sdq.scss","webpack://./src/scss/_aces.scss","webpack://./src/scss/_wally.scss","webpack://./src/scss/_corsi.scss","webpack://./src/scss/_moments.scss","webpack://./src/scss/_hnf.scss","webpack://./src/scss/_fonologico.scss","webpack://./src/scss/_responsiveA7.scss","webpack://./src/scss/_london-tower.scss","webpack://./src/scss/_esc.scss","webpack://./src/scss/styles.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;ACEJ;;ACHA;EACI,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;ADMJ;ACJI;EACI,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,WAAA;ADKR;ACHQ;EACI,WAAA;EACA,eAAA;ADKZ;ACFQ;EACI,kBAAA;EACA,gBAAA;ADIZ;;ACKA;EACI,sBAAA;EACA,0CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ADFJ;ACII;EACI,gCAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,WAAA;ADHR;ACKQ;EACI,WAAA;EACA,eAAA;ADHZ;ACMQ;EACI,kBAAA;EACA,gBAAA;ADJZ;;AE3DA;EACI,sBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;AF8DJ;AE5DI;EACI,qBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,eAAA;AF8DR;AE3DI;EACI,yBAAA;EACA,sBAAA;AF6DR;AE1DI;EACI,cAAA;EACA,UAAA;EACA,gCAAA;EACA,eAAA;AF4DR;AEzDI;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;AF2DR;;AEhDA;EACI,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,wBAAA;EACA,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;AFmDJ;;AEhDA;EACI,aAAA;EACA,wBAAA;EACA,gCAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kCAAA;EACA,0CAAA;EACA,uCAAA;EACA,sCAAA;EACA,qCAAA;AFmDJ;;AEhDA;EACI,WAAA;EACA,iBAAA;AFmDJ;;AEhDA;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AFmDJ;AEjDI;EACI,WAAA;AFmDR;;AE/CA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;AFkDJ;;AG7JA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAgDA;EACI,SAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AH+JJ;AG9JI;EACI,sBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EAEA,aAAA;EAEA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;AH8JR;AG3JQ;EACI,UAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;AH6JZ;AG1JQ;EACI,WAAA;EACA,kBAAA;AH4JZ;AG1JQ;EACI,WAAA;AH4JZ;AGzJQ;EACI,mBAAA;EACA,UAAA;EAEA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,2CAAA;EACA,sBAAA;EACA,eAAA;AH0JZ;AGpJQ;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AHsJZ;AGnJQ;EACI,WAAA;AHqJZ;;AIxQA,2EAAA;AAEA;+EAAA;AAGA;;;EAAA;AAKC;EACG,iBAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;AJwQJ;;AIrQE;+EAAA;AAGA;;EAAA;AAIA;EACE,SAAA;AJsQJ;;AInQE;;EAAA;AAIA;EACE,cAAA;AJqQJ;;AIlQE;;;EAAA;AAKA;EACE,cAAA;AJoQJ;;AIhQE;+EAAA;AAGA;;;EAAA;AAKA;EACE,uBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;AJiQJ;;AI9PE;;;EAAA;AAKA;EACE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;AJgQJ;;AI7PE;+EAAA;AAGA;;EAAA;AAIA;EACE,6BAAA;AJ8PJ;;AI3PE;;;EAAA;AAKA;EACE,mBAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,yCAAA;UAAA,iCAAA,EAAA,MAAA;AJ6PJ;;AI1PE;;EAAA;AAIA;;EAEE,mBAAA;AJ4PJ;;AIzPE;;;EAAA;AAKA;;;EAGE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;AJ2PJ;;AIxPE;;EAAA;AAIA;EACE,cAAA;AJ0PJ;;AIvPE;;;EAAA;AAKA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AJyPJ;;AItPE;EACE,eAAA;AJyPJ;;AItPE;EACE,WAAA;AJyPJ;;AItPE;+EAAA;AAGA;;EAAA;AAIA;EACE,kBAAA;AJuPJ;;AIpPE;+EAAA;AAGA;;;EAAA;AAKA;;;;;EAKE,oBAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;AJqPJ;;AIlPE;;;EAAA;AAKA;QACQ,MAAA;EACN,iBAAA;AJoPJ;;AIjPE;;;EAAA;AAKA;SACS,MAAA;EACP,oBAAA;AJmPJ;;AIhPE;;EAAA;AAIA;;;;EAIE,0BAAA;AJkPJ;;AI/OE;;EAAA;AAIA;;;;EAIE,kBAAA;EACA,UAAA;AJiPJ;;AI9OE;;EAAA;AAIA;;;;EAIE,8BAAA;AJgPJ;;AI7OE;;EAAA;AAIA;EACE,8BAAA;AJ+OJ;;AI5OE;;;;;EAAA;AAOA;EACE,sBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AJ8OJ;;AI3OE;;EAAA;AAIA;EACE,wBAAA;AJ6OJ;;AI1OE;;EAAA;AAIA;EACE,cAAA;AJ4OJ;;AIzOE;;;EAAA;AAKA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AJ2OJ;;AIxOE;;EAAA;AAIA;;EAEE,YAAA;AJ0OJ;;AIvOE;;;EAAA;AAKA;EACE,6BAAA,EAAA,MAAA;EACA,oBAAA,EAAA,MAAA;AJyOJ;;AItOE;;EAAA;AAIA;EACE,wBAAA;AJwOJ;;AIrOE;;;EAAA;AAKA;EACE,0BAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;AJuOJ;;AIpOE;+EAAA;AAGA;;EAAA;AAIA;EACE,cAAA;AJqOJ;;AIlOE;;EAAA;AAIA;EACE,kBAAA;AJoOJ;;AIjOE;+EAAA;AAGA;;EAAA;AAIA;EACE,aAAA;AJkOJ;;AI/NE;;EAAA;AAIA;EACE,aAAA;AJiOJ;;AK5jBA;EAII,kBAAA;EAgBA,aAAA;EACA,sBAAA;EACA,WAAA;AL6iBJ;AK7jBI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EAEA,YAAA;AL8jBR;AK1jBI;EACI,WAAA;AL4jBR;AKpjBI;EACI,aAAA;EACA,6BAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;ALsjBR;;AKljBA;EACI,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;ALqjBJ;;AKjjBA;EACI,eAAA;ALojBJ;;AM9lBA;EACI,WAAA;ANimBJ;;AM9lBA;EACI,kBAAA;ANimBJ;;AM9lBA;EACI,sBAAA;EACA,eAAA;ANimBJ;;AM9lBA;EACI,yBAAA;EACA,WAAA;ANimBJ;;AM7lBA;EACI,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,aAAA;ANgmBJ;AM5lBI;EACI,YAAA;EACA,cAAA;AN8lBR;;AOjoBA;EACI,WAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;APooBJ;AOloBI;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EACA,sBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;APooBR;AACA;EOloBQ,WAAA;EAEA,kBAAA;EPmoBN,sBAAsB;EOhoBhB,8BAAA;EACI,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;APkoBZ;AACA;EOhoBY,WAAA;EACA,eAAA;EPkoBV,qBAAqB;EO/nBf,iBAAA;EACI,WAAA;EACA,UAAA;APioBZ;AACA;EO/nBY,yBAAA;EACA,WAAA;APioBZ;;AAEA;EO/nBY,cAAA;EPioBV,UAAU;EO9nBJ,2BAAA;EACI,mCAAA;EACA,gCAAA;EPgoBV,+BAA+B;EAC/B,8BAA8B;AOxnBhC;;AP2nBA;EOxnBI,aAAA;EACA,UAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EP0nBF,+BAA+B;EAC/B,8BAA8B;AOvnBhC;;AP0nBA;EOvnBI,WAAA;EACA,kBAAA;EACA,iBAAA;APynBJ;;AAEA;EACE,sBAAsB;EOtnBxB,2BAAA;EACI,MAAA;EACA,OAAA;EACA,QAAA;EPwnBF,SAAS;EACT,YAAY;EQ7tBd,aAAA;EACI,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AR+tBJ;AACA;EQ5tBI,UAAA;EACA,cAAA;AR8tBJ;AACA;EQ5tBI,UAAA;EACA,iBAAA;ER8tBF,gBAAgB;EQ5tBd,cAAA;EACI,6BAAA;EACA,aAAA;ER8tBN,qBAAqB;EQ3tBnB,6BAAA;EACI,0BAAA;EACA,yBAAA;EACA,wBAAA;AR6tBR;AACA;EQ3tBQ,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;AR6tBR;AACA;EQ1tBI,gBAAA;AR4tBJ;;AAEA,qBQ3tBQ;AR4tBR;EQ1tBQ,iBAAA;ER4tBN,wBAAwB;AQxtBtB;AR0tBJ;EACE,eAAe;AACjB;AQvtBA;EAEA,eAAA;EAEQ,WAAA;EA0BA,qBAAA;ER8rBN,6BAA6B;EQvtBvB,0BAAA;EACI,yBAAA;ERytBV,wBAAwB;AQrtBlB;ARutBR;EQrtBY,yBAAA;EACA,WAAA;ARutBZ;AACA;EQrtBY,iBAAA;ARutBZ;;AQltBQ;EACI,iBAAA;EACA,iBAAA;ERqtBV,eAAe;EQltBT,+CAAA;EACI,aAAA;ERotBV,sBAAsB;EACtB,mBAAmB;EQ/sBrB,uBAAA;ARitBA;AACA;EQ/sBI,aAAA;EACA,mBAAA;EAEA,6BAAA;EACA,cAAA;EACA,eAAA;ARgtBJ;AACA;EQ5sBI,UAAA;AR8sBJ;AACA;EQ5sBQ,sBAAA;EACA,UAAA;EACA,cAAA;AR8sBR;AQ5sBQ;EACI,WAAA;ER8sBV,sBAAsB;EQtsBpB,eAAA;ARwsBJ;AACA;EQ/rBQ,aAAA;ARisBR;AQvsBQ;EACI,YAAA;ARysBZ;;AAEA;EQpsBQ,kBAAA;EACI,aAAA;ERssBV,uBAAuB;EQ/rBrB,mBAAA;EACI,qBAAA;ERisBN,sBAAsB;EACtB,UAAU;EQ9rBZ,iBAAA;ARgsBA;AACA;EQ9rBI,UAAA;EACA,iBAAA;ARgsBJ;AACA;EQ9rBI,UAAA;ARgsBJ;AACA;EQ7rBI,iBAAA;EACI,aAAA;AR+rBR;;AQ3rBI;EACI,aAAA;ER8rBN,sBAAsB;EQ5rBhB,uBAAA;EACI,mBAAA;EACA,iBAAA;ER8rBV,UAAU;AACZ;AQvrBA;EACI,sBAAA;ARyrBJ;AACA;EQvrBI,sBAAA;EACA,aAAA;EACA,iBAAA;ERyrBF,aAAa;EQvrBX,iBAAA;ARyrBJ;;AQrrBI;EACI,gBAAA;EACA,mBAAA;ARwrBR;;AAEA;EACE,sBAAsB;EACtB,UAAU;EQprBZ,iBAAA;ARsrBA;;AAEA;EACE,aAAa;EQnrBf,sBAAA;EACI,iBAAA;EACA,UAAA;EACA,sBAAA;ARqrBJ;AACA;EQlrBA,kBAAA;ARorBA;;AAEA;EQjrBI,uBAAA;EACA,wBAAA;ARmrBJ;;AAEA;EACE,UAAU;EACV,iBAAiB;EQ9qBnB,kBAAA;EACI,aAAA;EACA,oCAAA;ERgrBF,qBAAqB;EACrB,6BAA6B;ES14B/B,0BAAA;EACI,yBAAA;EACA,wBAAA;EACA,yBAAA;AT44BJ;AACA;ES14BI,WAAA;EACA,sBAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;AT44BJ;AS34BI;EACI,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;AT64BR;ASz4BI;EACI,eAAA;AT24BR;;AAEA;ESz4BQ,yBAAA;EACA,WAAA;ET24BN,aAAa;ESx4Bf,qBAAA;EACI,6BAAA;ET04BF,0BAA0B;EAC1B,yBAAyB;EU36B3B,wBAAA;EACI,2CAAA;AV66BJ;;AAEA;EU36BI,WAAA;EACA,aAAA;AV66BJ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EU16BI,aAAA;EV46BF,sBAAsB;EACtB,YAAY;EU16Bd,iBAAA;EAEI,WAAA;AV26BJ;AACA;EWh8BA,kBAAA;EAEI,eAAA;AXi8BJ;AACA;EW/7BI,YAAA;EACA,iBAAA;EXi8BF,kBAAkB;AW/7BhB;;AXk8BJ;EACE,aAAa;EW97BX,sBAAA;EACI,YAAA;EACA,iBAAA;EACA,WAAA;AXg8BR;AACA;EYj9BA,kBAAA;EAEI,eAAA;AZk9BJ;AACA;EYh9BI,YAAA;EACA,iBAAA;EZk9BF,kBAAkB;AYh9BhB;;AZm9BJ;EACE,YAAY;EY/8BV,gBAAA;AZi9BJ;;AAEA;EACE,aAAa;EACb,iCAAiC;Eal+BnC,oCAAA;EACI,iBAAA;EACA,WAAA;Abo+BJ;AACA;Eal+BA,YAAA;Abo+BA;;AAEA;Eal+BI,sBAAA;Abo+BJ;;Aal+BI;EACI,eAAA;Ebq+BN,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;Eal+BI,eAAA;Ebo+BF,gBAAgB;AAClB;Aa/9BA;EACI,iBAAA;Abi+BJ;;Aa99BA;EACI,YAAA;EACA,iCAAA;Abi+BJ;;AAEA;EACE,YAAY;EACZ,sBAAsB;Ea59BxB,uBAAA;Ab89BA;;AAEA;EACE,qBAAqB;Ea39BvB,sBAAA;EAGI,uBAAA;Ab29BJ;;AAEA;EACE,0BAA0B;Eaz9B5B,UAAA;EACI,SAAA;Ab29BJ;;AAEA;EACE,2BAA2B;Aav9B7B;;Ab09BA;Eav9BI,2BAAA;Aby9BJ;;Ac7hCA;EACI,gBAAA;AdgiCJ;;Ac5hCA;EACI,kBAAA;Ed+hCF,wBAAwB;EACxB,YAAY;Ac7hCd;Ad+hCA;Ec7hCI,UAAA;EACA,gBAAA;Ed+hCF,YAAY;Ac9hCV;;AdiiCJ;Ec9hCQ,2BAAA;AdgiCR;;Ac5hCA;EACI,kBAAA;Ed+hCF,aAAa;EACb,sBAAsB;Ec7hCxB,mBAAA;EACI,SAAA;Ad+hCJ;AACA;Ec7hCI,kBAAA;EACA,gBAAA;Ad+hCJ;;AAEA;Ec9hCQ,aAAA;EdgiCN,8BAA8B;EAC9B,kBAAkB;Ac7hCpB;;AdgiCA;Ec7hCA,kBAAA;Ed+hCE,wBAAwB;EACxB,YAAY;AevkCd;AfykCA;EevkCI,UAAA;EACA,gBAAA;EACA,YAAA;AfykCJ;;AAEA;EevkCI,2BAAA;AfykCJ;;AAEA;EACE,kBAAkB;EetkChB,aAAA;EAEI,sBAAA;EACA,mBAAA;EACA,SAAA;AfukCR;AACA;EerkCQ,kBAAA;EACA,gBAAA;AfukCR;;AAEA;EetkCY,aAAA;EACA,8BAAA;EfwkCV,kBAAkB;AerkCZ;;AfwkCR;EACE,sBAAsB;EepkChB,yBAAA;EACI,WAAA;EfskCV,aAAa;EenkCP,uBAAA;EACI,mBAAA;AfqkCZ;AACA;EenkCQ,kBAAA;EACI,WAAA;EACA,yBAAA;AfqkCZ;AenkCQ;EACI,aAAA;EACA,YAAA;EfqkCV,aAAa;EenkCP,eAAA;EACI,SAAA;EfqkCV,aAAa;EenkCP,iBAAA;AfqkCR;AACA;EACE,sBAAsB;EelkChB,WAAA;EACI,YAAA;AfokCZ;AACA;EelkCQ,iBAAA;EACI,gBAAA;AfokCZ;AACA;EelkCQ,iBAAA;AfokCR;AACA;EACE,iBAAiB;EehkCf,gBAAA;AfkkCJ;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;Ae9jCA;EACI,iBAAA;EACA,gBAAA;AfgkCJ;AACA;Ee9jCA,iBAAA;AfgkCA;AACA;EACE,iBAAiB;EACjB,iBAAiB;Ae9jCnB;AfgkCA;Ee9jCI,iBAAA;EfgkCF,iBAAiB;AACnB;Ae9jCA;EAAA,iBAAA;EAEI,gBAAA;AfgkCJ;AACA;EgBlqCA,iBAAA;EACI,iBAAA;AhBoqCJ;AACA;EgBnqCI;IACI,WAAA;EhBqqCN;AACF;;AAEA;EiBzqCI,oCAAA;EjB2qCF,yBAAyB;AiBzqCvB;;AjB4qCJ;EiBzqCQ,aAAA;EACA,kBAAA;AjB2qCR;;AAEA;EiBvqCI,sBAAA;EACI,kBAAA;AjByqCR;;AAEA;;EAEE,yBAAyB;AiBtqCvB;;AjByqCJ;EiBtqCQ,qBAAA;EjBwqCN,cAAc;AiBtqCR;AjBwqCR;EiBtqCY,eAAA;AjBwqCZ;;AAEA;IiBtqCY,aAAA;IjBwqCR,sBAAsB;EiBrqClB;EACI;IjBuqCR,aAAa;IACb,sBAAsB;IiBlqC1B,8BAAA;IACI,qBAAA;IACA,YAAA;IACA,6BAAA;EACA;EjBoqCF;IACE,UAAU;IiBhqCd,aAAA;IACI,qBAAA;IACA,sBAAA;IACA,UAAA;EACA;EACA;IjBkqCA,aAAa;IACb,6BAA6B;IiB/pCjC,qBAAA;EACI;EACA;IACA,YAAA;IACA,aAAA;IACA,qBAAA;IjBiqCA,YAAY;IiB9pCR,0CAAA;IACI,yBAAA;EACA;EACA;IjBgqCR,wCAAwC;EAC1C;;EiB3pCE;IACA,yDAAA;IjB8pCA,wBAAwB;IACxB,4BAA4B;IiB3pChC,2BAAA;EACI;;EAEA;IACA,yDAAA;IACA,wBAAA;IACA,4BAAA;IjB6pCA,2BAA2B;IAC3B,WAAW;EiB3pCf;;EAEI;IACA,kBAAA;IACA,WAAA;IACA,aAAA;IACA,WAAA;IjB6pCA,sBAAsB;EACxB;EiB3pCF;IACI,UAAA;IACA,iBAAA;IACA,kBAAA;EjB6pCF;;AiB1pCF;EACI,sBAAA;EACA,uBAAA;AjB6pCJ;;AAEA;EiB1pCA,yDAAA;EACI,wBAAA;EACA,4BAAA;EACA,2BAAA;EjB4pCF,YAAY;EACZ,aAAa;AiBzpCf;;AjB4pCA;EACE,yDAAqD;EACrD,wBAAwB;EiBzpC1B,4BAAA;EACI,2BAAA;EACA,YAAA;EACA,aAAA;AjB2pCJ;;AAEA;EACE,aAAa;EkBhyCf,6BAAA;EACI,gBAAA;AlBkyCJ;;AkB/xCA;EACI,UAAA;EACA,aAAA;ElBkyCF,kBAAkB;AACpB;;AAEA;EkBjyCI,qBAAA;EACA,WAAA;EACA,sBAAA;AlBmyCJ;;AAEA;EmB5yCA,UAAA;EACI,oCAAA;AnB8yCJ;;AAEA;EACE,amB5yCM;EnB6yCN,aAAa;EmB1yCX,uBAAA;EnB4yCF,mBmB3yCM;EnB4yCN,qBmB3yCM;AnB4yCR;;AAEA;EACE,eAAe;AACjB;;AAEA;EmBnyCQ,WAAA;EnBqyCN,yBmBpyCU;AnBqyCZ;;AAEA;EACE,amB/xCM;EnBgyCN,UAAU;EmB5xCR,cAAA;EAAA,iBAAA;EAAA,uBAAA;AnBgyCJ;;AAEA;EmBxxCI;IACI,kBAAA;EnB0xCN;EACA;ImBzxCM,4BAAA;EnB2xCN;EACA;ImBvxCE,iBAAA;IACI,qBAAA;EnByxCN;EACA;ImBtxCE,UAAA;EnBwxCF;EACA;ImBlxCM,UAAA;EnBoxCN;EACA;ImB5wCM,gBAAA;EnB8wCN;EACA;ImBvwCM,wBAAA;IACI,uBAAA;EnBywCV;EACA;;;ImBrwCc,sBAAA;InBywCZ,uBAAuB;EmBlwCvB;EnBowCF;IACE,WAAW;ImBjwCX,YAAA;EnBmwCF;EACA;ImBjwCM,sBAAA;EnBmwCN;EmB5vCM;IACI,kBAAA;IACA,mBAAA;EnB8vCV;EACA;ImB5vCU,eAAA;EnB8vCV;EACA;IACE,gBAAgB;EoB53CpB;EACI;IACA,gBAAA;EACA;EACA;IpB83CA,YAAY;EACd;EoB53CF;IACI,aAAA;IACA,YAAA;IACA,aAAA;EACA;EpB83CF;IACE,eAAe;EoB53CnB;EACI;IACA,iBAAA;EACA;EACA;IpB83CA,aAAa;IACb,cAAc;IqBj5ClB,WAAA;EACI;EACA;IACA,uBAAA;IACA,wBAAA;IACA,qBAAA;IACA,YAAA;IrBm5CA,0CAA0C;IAC1C,yBAAyB;EqB/4C7B;ArBi5CA;AACA;EqB/4CI,yDAAA;ErBi5CF,2BAA2B;EAC3B,4BAA4B;EqB/4C9B,2BAAA;ArBi5CA;;AAEA;EACE,yDAAiD;EqBh5CnD,2BAAA;EACI,4BAAA;ErBk5CF,2BAA2B;AAC7B;;AAEA;EACE,yDAAiD;EACjD,2BAA2B;EqBh5C7B,4BAAA;EACI,2BAAA;ArBk5CJ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EqB/4CT,QAAA;EACI,iBAAA;EACA,kBAAA;EACA,YAAA,EAAA,kCAAA;ArBi5CJ;;AAEA;EACE,YAAY;EACZ,aAAa;EqB94Cf,sBAAA;ArBg5CA;;AAEA;EACE,aqB/4CU;ErBg5CV,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EsB76CI,aAAA;EACG,uBAAA;EACC,mBAAA;EACI,qBAAA;AtB+6CZ;;AsB56CA;EACI,aAAA;EtB+6CF,mBAAmB;EACnB,eAAe;EsB76CjB,WAAA;EACI,mBAAA;EACA,2BAAA;AtB+6CJ;;AsB56CA;EACI;ItB+6CA,YAAY;IACZ,aAAa;IsB76CjB,sBAAA;EACI;AtB+6CJ;AACA;EACE,sBAAsB;AsB96CxB;;AtBi7CA;EACE,YAAY;AsB/6Cd;;AtBk7CA;EsB/6CI,2BAAA,EAAA,WAAA;EACA,yBAAA,EAAA,WAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AtBi7CJ;;AAEA;EsB/6CI,oBAAA;AtBi7CJ;;AAEA;EsB/6CA,sBAAA;EAAA,aAAA;AtBk7CA;;AAEA;EsB/6CA,iCAAA;AtBi7CA;;AAEA;EsB/6CA,YAAA;EACI,gBAAA;AtBi7CJ;;AsB96CA;EACI,6BAAA;AtBi7CJ;;AsB76CA;;EAIE,yBAAA;EtB86CA,sBAAsB;EACtB,sBAAsB;EsB56CxB,2BAAA;EACI,aAAA;EACA,mBAAA;EtB86CF,2BAA2B;EAC3B,wBAAwB;EsBv6C1B,uBAAA;EACI,sBAAA;EACA,2CAAA;AtBy6CJ;;AAEA;;EsBr6CI,2CAAA;AtBw6CJ;;AAEA;EsBr6CI,kBAAA;AtBu6CJ;;AsBp6CQ;EACI,iBAAA;AtBu6CZ;;AAEA;EsBp6CY,oCAAA;AtBs6CZ;;AAEA,qFAAqF;AsBr6CzE;EACI,yCAAA;AtBu6ChB;;AAEA;EsBp6CgB,YAAA;EACA,cAAA;AtBs6ChB;;AAEA;EACE,kBAAkB;EsB75ChB,kBAAA;EACI,WAAA;AtB+5CR;;AAEA;EsB75CQ,YAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AtB+5CR;AACA;EsB75CQ,UAAA;EtB+5CN,aAAa;EsB75CP,eAAA;EACI,uBAAA;EACA,yBAAA;EACA,WAAA;EAEA,eAAA;AtB85CZ;AACA;EsB55CY,WAAA;EACA,YAAA;EACA,yBAAA;EtB85CV,kBAAkB;EAClB,0BAA0B;EsBt5C5B,uBAAA;EACI,sBAAA;EACA,qBAAA;EACA,2CAAA;AtBw5CJ;AACA;EsBt5CI,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,2CAAA;EACA,qBAAA;EtBw5CF,6BAA6B;EAC7B,0BAA0B;EsBt5C5B,yBAAA;EACI,wBAAA;AtBw5CJ;AACA;EACE,WAAW;EsBt5Cb,YAAA;EACI,yBAAA;EtBw5CF,kBAAkB;EAClB,2CAA2C;EsBt5C7C,0BAAA;EACI,uBAAA;EtBw5CF,sBAAsB;EACtB,qBAAqB;AsBt5CvB;;AtBy5CA;EsBt5CI,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,YAAA;EACA,wBAAA;AtBw5CJ;;AsBr5CA;EACI,WAAA;EACA,0BAAA;AtBw5CJ;;AAEA;EsBt5CI,uBAAA;AtBw5CJ;;AsBr5CA;EACI,sCAAA;AtBw5CJ;;AAEA;EsBt5CI,WAAA;EtBw5CF,YAAY;EsBv5CV,aAAA;EACI,YAAA;EACA,eAAA;EtBy5CN,kBAAkB;EsBt5ChB,UAAA;EACI,WAAA;EtBw5CN,kBAAkB;EAClB,0BAA0B;EsBr5C5B,uBAAA;EACA,sBAAA;EAAA,qBAAA;EAEE,2CAAA;EACA,yBAAA;EtBu5CA,cAAc;AAChB;;AsBp5CA;EACE,WAAA;EtBu5CA,aAAa;EACb,mBAAmB;EsBn5CrB,qBAAA;EACI,uBAAA;EACA,kBAAA;AtBq5CJ;;AAEA;EsBn5CI,aAAA;EtBq5CF,2BAA2B;EsBj5CzB,mBAAA;EACI,qBAAA;EACA,SAAA;AtBm5CR;AACA;EACE,eAAe;EsB/4CjB,iBAAA;AtBi5CA;AACA;EsB/4CI,UAAA;AtBi5CJ;;AAEA,gCsBh5CI;AtBi5CJ;;EsB94CI,wBAAA;EACA,SAAA;AtBi5CJ;;AsB74CA,YAAA;AtBg5CA;EsB94CI,0BAAA;AtBg5CJ;;AAEA;EsB94CI,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;AtBg5CJ;AACA;EACE,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yDAA2D;EAC3D,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,yDAA2D;EAC3D,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;;;;;AAKA,oGAAoG;AACpG;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,4CAA4C;IAC5C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,UAAU,EAAE,wDAAwD;AACxE;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,qCAAqC,EAAE,uBAAuB;IAC9D,kCAAkC,EAAE,oBAAoB;IACxD,SAAS,EAAE,8BAA8B;IACzC,YAAY,EAAE,gCAAgC;IAC9C,aAAa,EAAE,+BAA+B;AAClD;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,WAAW,EAAE,+BAA+B;AAChD;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,WAAW,EAAE,+BAA+B;AAChD;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,iGAAiG;AACjG;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,4CAA4C;IAC5C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,UAAU,EAAE,wDAAwD;AACxE;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,qCAAqC,EAAE,uBAAuB;IAC9D,kCAAkC,EAAE,oBAAoB;IACxD,SAAS,EAAE,8BAA8B;IACzC,YAAY,EAAE,gCAAgC;IAC9C,aAAa,EAAE,+BAA+B;AAClD;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,WAAW,EAAE,+BAA+B;AAChD;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,WAAW,EAAE,+BAA+B;AAChD;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0FAA0F;;AAE1F,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB,EAAE,yCAAyC;IACjE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;;AAEA,0BAA0B;AAC1B;IACI,UAAU;IACV,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,8BAA8B,EAAE,qBAAqB;AACzD;;AAEA,oBAAoB;AACpB;IACI,YAAY,EAAE,sDAAsD;IACpE,YAAY,EAAE,wCAAwC;AAC1D;;AAEA,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,oBAAoB;IACpB,yBAAyB,EAAE,oCAAoC;IAC/D,iBAAiB,EAAE,mEAAmE;IACtF,oBAAoB,EAAE,mEAAmE;IACzF,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB,EAAE,sCAAsC;IAC3D,4BAA4B,EAAE,uBAAuB;IACrD,kBAAkB,EAAE,0CAA0C;IAC9D,0CAA0C,EAAE,6CAA6C;AAC7F;;;AAGA,wBAAwB;AACxB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB,EAAE,oCAAoC;IAC/D,4CAA4C;IAC5C,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,YAAY,EAAE,yBAAyB;IACvC,aAAa,EAAE,wBAAwB;IACvC,qBAAqB,EAAE,kCAAkC;IACzD,kCAAkC,EAAE,6CAA6C;IACjF,WAAW,EAAE,mCAAmC;AACpD;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB,EAAE,gDAAgD;IACpE,yBAAyB,EAAE,gDAAgD;AAC/E;;AAEA;IACI,kBAAkB,EAAE,gDAAgD;IACpE,yBAAyB,EAAE,gDAAgD;AAC/E;;;AAGA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAE,uBAAuB;IAC3C,yBAAyB,EAAE,6BAA6B;IACxD,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB,EAAE,gDAAgD;IACpE,yBAAyB,EAAE,gDAAgD;AAC/E;;AAEA;IACI,WAAW,EAAE,kCAAkC;IAC/C,YAAY;AAChB;;AAEA;IACI,eAAe,EAAE,gDAAgD;IACjE,mBAAmB,EAAE,8CAA8C;IACnE,iBAAiB,EAAE,gCAAgC;IACnD,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB,EAAE,uBAAuB;IAC9C,yBAAyB,EAAE,mBAAmB;IAC9C,eAAe,EAAE,oDAAoD;IACrE,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB,EAAE,4CAA4C;IAChE,QAAQ,EAAE,kCAAkC;IAC5C,SAAS,EAAE,oCAAoC;IAC/C,gCAAgC,EAAE,kDAAkD;IACpF,mBAAmB,EAAE,oBAAoB;IACzC,eAAe,EAAE,wBAAwB;IACzC,iBAAiB,EAAE,YAAY;IAC/B,oBAAoB,EAAE,0DAA0D;AACpF;;AAEA,iGAAiG;;AAEjG,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB,EAAE,yCAAyC;IACjE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;;AAEA,0BAA0B;AAC1B;IACI,UAAU;IACV,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,8BAA8B,EAAE,qBAAqB;AACzD;;AAEA,oBAAoB;AACpB;IACI,YAAY,EAAE,sDAAsD;IACpE,YAAY,EAAE,wCAAwC;AAC1D;;AAEA,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,oBAAoB;IACpB,yBAAyB,EAAE,oCAAoC;IAC/D,iBAAiB,EAAE,mEAAmE;IACtF,oBAAoB,EAAE,mEAAmE;IACzF,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB,EAAE,sCAAsC;IAC3D,4BAA4B,EAAE,uBAAuB;IACrD,kBAAkB,EAAE,0CAA0C;IAC9D,0CAA0C,EAAE,6CAA6C;AAC7F;;;AAGA,wBAAwB;AACxB;IACI,aAAa,EAAE,oCAAoC;IACnD,sBAAsB,EAAE,6CAA6C;IACrE,uBAAuB,EAAE,sCAAsC;IAC/D,mBAAmB,EAAE,wCAAwC;IAC7D,kBAAkB;IAClB,yBAAyB,EAAE,oCAAoC;IAC/D,4CAA4C;IAC5C,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,YAAY,EAAE,yBAAyB;IACvC,aAAa,EAAE,wBAAwB;IACvC,qBAAqB,EAAE,kCAAkC;IACzD,kCAAkC,EAAE,6CAA6C;IACjF,WAAW,EAAE,mCAAmC;AACpD;;AAEA,gCAAgC;AAChC;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB,EAAE,gDAAgD;IACpE,yBAAyB,EAAE,gDAAgD;AAC/E;;AAEA;IACI,eAAe,EAAE,gDAAgD;IACjE,mBAAmB,EAAE,8CAA8C;IACnE,iBAAiB,EAAE,gCAAgC;IACnD,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB,EAAE,uBAAuB;IAC9C,yBAAyB,EAAE,mBAAmB;IAC9C,eAAe,EAAE,oDAAoD;IACrE,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB,EAAE,4CAA4C;IAChE,QAAQ,EAAE,kCAAkC;IAC5C,SAAS,EAAE,oCAAoC;IAC/C,gCAAgC,EAAE,kDAAkD;IACpF,mBAAmB,EAAE,oBAAoB;IACzC,eAAe,EAAE,wBAAwB;IACzC,iBAAiB,EAAE,YAAY;IAC/B,oBAAoB,EAAE,0DAA0D;AACpF;;AAEA,4FAA4F;;AAE5F,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB,EAAE,yCAAyC;IACjE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;;AAEA,0BAA0B;AAC1B;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,8BAA8B,EAAE,qBAAqB;AACzD;;AAEA,oBAAoB;AACpB;IACI,YAAY,EAAE,sDAAsD;IACpE,YAAY,EAAE,wCAAwC;AAC1D;;AAEA,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,oBAAoB;IACpB,yBAAyB,EAAE,oCAAoC;IAC/D,iBAAiB,EAAE,mEAAmE;IACtF,oBAAoB,EAAE,mEAAmE;IACzF,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB,EAAE,0CAA0C;AAClE;;AAEA;IACI,aAAa,EAAE,oCAAoC;IACnD,sBAAsB,EAAE,6CAA6C;IACrE,uBAAuB,EAAE,sCAAsC;IAC/D,mBAAmB,EAAE,wCAAwC;IAC7D,kBAAkB;IAClB,yBAAyB,EAAE,oCAAoC;IAC/D,4CAA4C;IAC5C,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,WAAW,EAAE,yBAAyB;IACtC,YAAY,EAAE,wBAAwB;IACtC,qBAAqB,EAAE,kCAAkC;IACzD,kCAAkC,EAAE,6CAA6C;IACjF,WAAW,EAAE,mCAAmC;AACpD;;AAEA,YAAY;AACZ;IACI,aAAa,EAAE,oCAAoC;IACnD,sBAAsB,EAAE,6CAA6C;IACrE,uBAAuB,EAAE,sCAAsC;IAC/D,mBAAmB,EAAE,wCAAwC;IAC7D,iBAAiB;IACjB,yBAAyB,EAAE,oCAAoC;IAC/D,4CAA4C;IAC5C,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,WAAW,EAAE,yBAAyB;IACtC,YAAY,EAAE,wBAAwB;IACtC,qBAAqB,EAAE,kCAAkC;IACzD,kCAAkC,EAAE,6CAA6C;IACjF,WAAW,EAAE,mCAAmC;AACpD;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB,EAAE,gDAAgD;IACpE,yBAAyB,EAAE,gDAAgD;AAC/E;;AAEA;IACI,eAAe,EAAE,gDAAgD;IACjE,mBAAmB,EAAE,8CAA8C;IACnE,iBAAiB,EAAE,gCAAgC;IACnD,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB,EAAE,uBAAuB;IAC9C,yBAAyB,EAAE,mBAAmB;IAC9C,eAAe,EAAE,oDAAoD;IACrE,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB,EAAE,4CAA4C;IAChE,QAAQ,EAAE,kCAAkC;IAC5C,SAAS,EAAE,oCAAoC;IAC/C,gCAAgC,EAAE,kDAAkD;IACpF,mBAAmB,EAAE,oBAAoB;IACzC,eAAe,EAAE,wBAAwB;IACzC,iBAAiB,EAAE,YAAY;IAC/B,oBAAoB,EAAE,0DAA0D;AACpF;;AAEA,mGAAmG;AACnG;IACI,SAAS;IACT,UAAU;IACV,aAAa,EAAE,yCAAyC;IACxD,YAAY,EAAE,0CAA0C;IACxD,uBAAuB;IACvB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,sCAAsC;IAC/D,mBAAmB,EAAE,wCAAwC;IAC7D,gBAAgB,EAAE,mCAAmC;AACzD;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW,EAAE,qDAAqD;IAClE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,2CAA2C;IAC1D,YAAY,GAAG,wDAAwD;IACvE,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,oEAAoE;AACpE;IACI,iBAAiB,EAAE,+BAA+B;IAClD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA,mCAAmC;AACnC;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,YAAY,EAAE,wCAAwC;IACtD,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,qCAAqC,EAAE,2CAA2C;IAClF,mBAAmB,EAAE,6CAA6C;AACtE;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY,EAAE,oCAAoC;IAClD,YAAY;IACZ,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,SAAS,EAAE,8BAA8B;IACzC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA,kGAAkG;AAClG,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,qDAAqD;AACxE;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB,EAAE,wCAAwC;IAC1D,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,eAAe,EAAE,gDAAgD;IACjE,YAAY,EAAE,2CAA2C;IACzD,gBAAgB,EAAE,gDAAgD;AACtE;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA,2CAA2C;AAC3C;IACI,sBAAsB,EAAE,gDAAgD;IACxE,yBAAyB,EAAE,gDAAgD;IAC3E,YAAY;IACZ,iBAAiB;AACrB;;;AAGA;IACI,6BAA6B;IAC7B,YAAY;AAChB","sourcesContent":["body {\n    background-color:#fff;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Kanit:wght@800;900&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,400;1,500;1,700;1,900&display=swap\");\nbody {\n  background-color: #fff;\n}\n\n.header {\n  background-color: #1674d8;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-content: baseline;\n}\n.header .selb-icon-wrapper {\n  font-family: \"Kanit\", sans-serif;\n  color: #fff;\n  font-weight: 800;\n  letter-spacing: 1px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: space-evenly;\n  gap: 1.5rem;\n}\n.header .selb-icon-wrapper #refresh-icon {\n  width: 30px;\n  cursor: pointer;\n}\n.header .selb-icon-wrapper h4 {\n  margin-right: 2rem;\n  margin-bottom: 0;\n}\n\n.header-japi {\n  background-color: #fff;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-content: baseline;\n  position: sticky;\n}\n.header-japi .japi-icon-wrapper {\n  font-family: \"Kanit\", sans-serif;\n  color: rgb(56, 163, 165);\n  font-weight: 800;\n  letter-spacing: 1px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: space-evenly;\n  gap: 1.5rem;\n}\n.header-japi .japi-icon-wrapper #refresh-icon {\n  width: 30px;\n  cursor: pointer;\n}\n.header-japi .japi-icon-wrapper h4 {\n  margin-right: 2rem;\n  margin-bottom: 0;\n}\n\n.aside-bar {\n  background-color: #fff;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex-direction: column;\n  width: 220px;\n  margin-top: 1rem;\n  padding: 0.5rem;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);\n  position: fixed;\n  z-index: 10;\n  border-radius: 1rem;\n  -webkit-border-radius: 1rem;\n  -moz-border-radius: 1rem;\n  -ms-border-radius: 1rem;\n  -o-border-radius: 1rem;\n}\n.aside-bar a {\n  text-decoration: none;\n  color: #333;\n  padding: 0.5rem 1rem;\n  margin: 0.5rem 0;\n  border-radius: 0.8rem;\n  -webkit-border-radius: 0.8rem;\n  -moz-border-radius: 0.8rem;\n  -ms-border-radius: 0.8rem;\n  -o-border-radius: 0.8rem;\n  cursor: pointer;\n}\n.aside-bar a:hover {\n  background-color: #7ebdc2;\n  color: #fff !important;\n}\n.aside-bar .aside-head {\n  display: block;\n  width: 80%;\n  border-bottom: 1px solid #284b63;\n  padding: 1rem 0;\n}\n.aside-bar .aside-menu {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem 0;\n  width: 80%;\n}\n\n.aside-bar-hidden {\n  transform: translate(-100%);\n  -webkit-transform: translate(-100%);\n  -moz-transform: translate(-100%);\n  -ms-transform: translate(-100%);\n  -o-transform: translate(-100%);\n  transition: 0.5s ease-in;\n  -webkit-transition: 0.5s ease-in;\n  -moz-transition: 0.5s ease-in;\n  -ms-transition: 0.5s ease-in;\n  -o-transition: 0.5s ease-in;\n}\n\n.aside-bar-active {\n  z-index: 9999;\n  transform: translate(0%);\n  -webkit-transform: translate(0%);\n  -moz-transform: translate(0%);\n  -ms-transform: translate(0%);\n  -o-transform: translate(0%);\n  transition: translate 0.5s ease in;\n  -webkit-transition: translate 0.5s ease in;\n  -moz-transition: translate 0.5s ease in;\n  -ms-transition: translate 0.5s ease in;\n  -o-transition: translate 0.5s ease in;\n}\n\n.active {\n  color: #fff;\n  font-weight: bold;\n}\n\n.profile-picture-wrapper {\n  margin-bottom: 1rem;\n  overflow: hidden;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  border: 1px solid #ccc;\n}\n.profile-picture-wrapper img {\n  width: 60px;\n}\n\n#home-icon, #students-icon, #users-icon, #logout-icon, #excel-icon, #parents-icon, #moment-icon, #development-icon {\n  width: 20px;\n  margin-bottom: 3px;\n  margin-right: 4px;\n}\n\n/* .login {\n    background-color:rgb(200, 217, 231);\n    margin:3rem auto;\n    width:50%;\n    max-width:600px;\n    min-width:250px;\n    border-radius:.5rem;\n    -webkit-border-radius:.5rem;\n    -moz-border-radius:.5rem;\n    -ms-border-radius:.5rem;\n    -o-border-radius:.5rem;\n\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    padding:2rem;\n\n    #loginForm {\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        align-content: center;\n        gap:.5rem;\n\n        img {\n            width:50%;\n        }\n\n        input {\n            width:70%;\n            min-width:200px;\n            max-width:450px;\n            padding:.5rem;\n            background-color:#fff;\n            border:1px solid #ddd;\n            border-radius:.5rem;        ;\n            -webkit-border-radius:.5rem        ;\n            -moz-border-radius:.5rem        ;\n            -ms-border-radius:.5rem        ;\n            -o-border-radius:.5rem        ;\n}\n\n    }\n} */\n.signin {\n  margin: 0;\n  height: 95vh;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n.signin .signin-form {\n  border: 1px solid #ccc;\n  width: 70%;\n  max-width: 1000px;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 6rem 2rem;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.signin .signin-form img {\n  width: 50%;\n  max-width: 200px;\n  margin: 0 auto;\n  padding: 0;\n  line-height: 0;\n}\n.signin .signin-form .signin-title {\n  color: #fff;\n  text-align: center;\n}\n.signin .signin-form label {\n  color: #fff;\n}\n.signin .signin-form input {\n  margin: 0.4rem auto;\n  width: 40%;\n  min-width: 200px;\n  max-width: 400px;\n  border: none;\n  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  padding: 0.4rem;\n}\n.signin .signin-form #signin-button {\n  display: inline;\n  margin: 0 auto;\n  padding: 0.4rem;\n  width: 100px;\n  margin-top: 0.4rem;\n}\n.signin .signin-form .signin-title {\n  color: #444;\n}\n\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n/* Document\n   ========================================================================== */\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n/**\n * Remove the margin in all browsers.\n */\nbody {\n  margin: 0;\n}\n\n/**\n * Render the `main` element consistently in IE.\n */\nmain {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\nh1 {\n  font-size: 2em;\n}\n\n/* Grouping content\n   ========================================================================== */\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n/**\n * Remove the gray background on active links in IE 10.\n */\na {\n  background-color: transparent;\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n/**\n * Remove the border on images inside links in IE 10.\n */\nimg {\n  border-style: none;\n}\n\n/* Forms\n   ========================================================================== */\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\nbutton:-moz-focusring,\n[type=button]:-moz-focusring,\n[type=reset]:-moz-focusring,\n[type=submit]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n[type=checkbox],\n[type=radio] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n[type=search] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\ndetails {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\nsummary {\n  display: list-item;\n}\n\n/* Misc\n   ========================================================================== */\n/**\n * Add the correct display in IE 10+.\n */\ntemplate {\n  display: none;\n}\n\n/**\n * Add the correct display in IE 10.\n */\n[hidden] {\n  display: none;\n}\n\n.home-wrapper {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.home-wrapper h1 {\n  padding: 2rem;\n  color: #444;\n  text-align: center;\n  height: 100%;\n}\n.home-wrapper h4 {\n  color: #444;\n}\n.home-wrapper .table-wrapper {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: baseline;\n  align-content: center;\n  flex-wrap: wrap;\n}\n\n.table-home {\n  width: 300px !important;\n  margin: 2rem auto;\n  border: 1px solid #444;\n  color: #333;\n}\n\n.selb-info {\n  cursor: pointer;\n}\n\n.kid-icon {\n  width: 30px;\n}\n\n.genre {\n  text-align: center;\n}\n\n.listed-student {\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.listed-student:hover {\n  background-color: #3AAFB9;\n  color: #fff;\n}\n\n.student-list-wrapper {\n  min-width: 300px;\n  width: 95%;\n  margin: 1rem auto;\n  border-radius: 0.4rem;\n  -webkit-border-radius: 0.4rem;\n  -moz-border-radius: 0.4rem;\n  -ms-border-radius: 0.4rem;\n  -o-border-radius: 0.4rem;\n  border: 1px solid #ccc;\n  padding: 1rem;\n}\n.student-list-wrapper select {\n  width: 300px;\n  margin: 0 auto;\n}\n\n#instruments-list-wrapper {\n  width: 100%;\n  height: 100vh;\n  background: rgba(244, 244, 244, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n#instruments-list-wrapper #instruments-list {\n  position: fixed;\n  width: 700px;\n  height: 480px;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);\n  background-color: #fff;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 0.8rem;\n  padding: 1.2rem;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  align-items: start;\n  align-content: flex-start;\n  z-index: 20;\n}\n#instruments-list-wrapper #instruments-list h4 {\n  width: 100%;\n  text-align: center;\n  border-radius: inherit;\n  -webkit-border-radius: inherit;\n  -moz-border-radius: inherit;\n  -ms-border-radius: inherit;\n  -o-border-radius: inherit;\n  padding: inherit;\n  color: #3aafb9;\n  font-weight: bold;\n  padding: 0;\n  margin: 0;\n  font-family: \"Kanit\", sans-serif;\n  letter-spacing: 1px;\n}\n#instruments-list-wrapper #instruments-list .listed-instrument {\n  width: 100%;\n  cursor: pointer;\n  border-radius: 0.4rem;\n  font-weight: bold;\n  color: #555;\n  padding: 0;\n}\n#instruments-list-wrapper #instruments-list .listed-instrument:hover {\n  background-color: #3aafb9;\n  color: #fff;\n}\n\n.active {\n  display: block;\n  opacity: 1;\n  transition: opacity 1s ease;\n  -webkit-transition: opacity 1s ease;\n  -moz-transition: opacity 1s ease;\n  -ms-transition: opacity 1s ease;\n  -o-transition: opacity 1s ease;\n}\n\n.hidden {\n  display: none;\n  opacity: 0;\n  transition: opacity 1s ease;\n  -webkit-transition: opacity 1s ease;\n  -moz-transition: opacity 1s ease;\n  -ms-transition: opacity 1s ease;\n  -o-transition: opacity 1s ease;\n}\n\n#instrument-icon {\n  width: 30px;\n  margin-bottom: 1px;\n  margin-right: 4px;\n}\n\n.page-item {\n  background-color: #fff;\n  height: calc(100vh - 120px);\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n}\n.page-item .letter-example {\n  width: 80%;\n  margin: 0 auto;\n}\n.page-item .main-description {\n  width: 60%;\n  line-height: 2rem;\n  min-width: 300px;\n  margin: 0 auto;\n  background-color: transparent;\n  padding: 2rem;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.page-item form {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  padding: 2rem;\n}\n.page-item img {\n  max-width: 600px;\n}\n\n/* First Instrument */\n.instrument-form {\n  text-align: start;\n  padding: 1rem !important;\n}\n.instrument-form input, .instrument-form label {\n  padding: 0.6rem;\n}\n.instrument-form label {\n  cursor: pointer;\n  width: 100%;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.instrument-form label:hover {\n  background-color: #3aafb9;\n  color: #fff;\n}\n.instrument-form label > input[type=radio] {\n  margin-right: 5px;\n}\n\n.sdq-wrapper {\n  max-width: 1100px;\n  margin: 1rem auto;\n  padding: 2rem 0;\n  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.sdq-wrapper .sdq-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  width: inherit;\n  padding: 2rem 0;\n}\n.sdq-wrapper .sdq-header img {\n  width: 40%;\n}\n.sdq-wrapper .sdq-instructions {\n  border: 1px solid #ccc;\n  width: 90%;\n  margin: 0 auto;\n}\n.sdq-wrapper .sdq-instructions h6 {\n  width: 100%;\n  background-color: #ccc;\n  padding: 0.5rem;\n}\n.sdq-wrapper .sdq-instructions p {\n  padding: 1rem;\n}\n.sdq-wrapper #sdq-btn {\n  width: 150px;\n}\n\n.instrument-sdq {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  border: 1px solid #ddd;\n  width: 90%;\n  margin: 1rem auto;\n}\n.instrument-sdq .sdq-title {\n  width: 40%;\n  text-align: start;\n}\n.instrument-sdq .sdq-option {\n  width: 60%;\n}\n.instrument-sdq .sdq-option label {\n  margin-left: 20px;\n  padding: 0rem;\n}\n\n.instrument-sdq__open {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 1rem auto;\n  width: 90%;\n}\n.instrument-sdq__open h6 {\n  align-self: flex-start;\n}\n.instrument-sdq__open textarea {\n  align-self: flex-start;\n  width: 1000px;\n  text-align: start;\n  padding: 1rem;\n  max-height: 200px;\n}\n\n.instrument-multiple {\n  max-width: 900px;\n  margin-bottom: 1rem;\n}\n\n.multipleChoicesWrapper {\n  border: 1px solid #ddd;\n  width: 90%;\n  margin: 1rem auto;\n}\n\n.instrument-sdq__extended {\n  display: flex;\n  border: 1px solid #ddd;\n  margin: 1rem auto;\n  width: 90%;\n  flex-direction: column;\n}\n.instrument-sdq__extended .sdq-option {\n  text-align: center;\n}\n\n.aces-item {\n  width: 100px !important;\n  height: 100px !important;\n}\n\n.book-wrapper {\n  width: 98%;\n  margin-left: 1rem;\n  margin-right: 1rem;\n  padding: 1rem;\n  box-shadow: 0px 1px 2px rgb(0, 0, 0);\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n  background-color: #CED4AC;\n}\n.book-wrapper .demopage {\n  width: 100%;\n  border-radius: inherit;\n  -webkit-border-radius: inherit;\n  -moz-border-radius: inherit;\n  -ms-border-radius: inherit;\n  -o-border-radius: inherit;\n}\n.book-wrapper .stf__block {\n  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.8);\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.book-wrapper img {\n  max-width: 100%;\n}\n\n.instruction {\n  background-color: #3AAFB9;\n  color: #fff;\n  padding: 2rem;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);\n}\n\n.statement {\n  color: #444;\n  padding: 2rem;\n}\n\n.statement-instruction {\n  font-size: 3.5rem;\n}\n\n.excel-container {\n  display: flex;\n  flex-direction: column;\n  width: 800px;\n  margin: 2rem auto;\n  gap: 0.5rem;\n}\n.excel-container h2 {\n  text-align: center;\n  padding: 2rem 0;\n}\n.excel-container #btn-excel {\n  width: 150px;\n  margin: 1rem auto;\n  text-align: center;\n}\n\n.sdq-form-container {\n  display: flex;\n  flex-direction: column;\n  width: 800px;\n  margin: 2rem auto;\n  gap: 0.5rem;\n}\n.sdq-form-container h2 {\n  text-align: center;\n  padding: 2rem 0;\n}\n.sdq-form-container .btn-parent {\n  width: 150px;\n  margin: 1rem auto;\n  text-align: center;\n}\n\n.aces-test {\n  height: 100%;\n  overflow: hidden;\n}\n\n.aces-direction {\n  display: flex;\n  flex-direction: column !important;\n  transform: rotate(270deg) !important;\n  flex-wrap: nowrap;\n  width: 100%;\n}\n.aces-direction img {\n  width: 450px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.aces-page-item {\n  max-width: 100%;\n  margin-left: 0;\n}\n\n.next {\n  width: 200px;\n}\n\n.aces-next {\n  max-width: 100%;\n  overflow: hidden;\n}\n.aces-next p {\n  max-width: 1100px;\n}\n\n.aces-content-wrapper {\n  width: 600px;\n  flex-direction: column !important;\n}\n\n#root > div.aces-test > div > div.swiper-button-prev {\n  padding: 0px;\n  width: 40px !important;\n  height: 40px !important;\n}\n\n#root > div.aces-test > div > div.swiper-button-next {\n  padding: 0 !important;\n  width: 40px !important;\n  height: 40px !important;\n}\n\n.swiper-button-next:after, .swiper-button-prev:after {\n  font-size: 1rem !important;\n  padding: 0;\n  margin: 0;\n}\n\n.wally-emotion {\n  max-width: 170px !important;\n}\n\n.eml-emotion {\n  max-width: 170px !important;\n}\n\n#swiper-wrapper-47465d4421825ce4 > div.swiper-slide.swiper-slide-active > div > img {\n  max-width: 450px;\n}\n\n.item-image-wally {\n  text-align: center;\n  margin: 4rem auto 0 auto;\n  width: 900px;\n}\n.item-image-wally img {\n  width: 80%;\n  max-width: 600px;\n  margin: 1rem;\n}\n\n.wally-action {\n  max-width: 230px !important;\n}\n\n.wally-label {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n.wally-label p {\n  text-align: center;\n  font-weight: 700;\n}\n\n.wally-form {\n  display: flex;\n  flex-direction: row !important;\n  /*     gap:2rem; */\n}\n\n.item-image-eml {\n  text-align: center;\n  margin: 4rem auto 0 auto;\n  width: 900px;\n}\n.item-image-eml img {\n  width: 80%;\n  max-width: 600px;\n  margin: 1rem;\n}\n\n.eml-action {\n  max-width: 230px !important;\n}\n\n.eml-label {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n.eml-label p {\n  text-align: center;\n  font-weight: 700;\n}\n\n.eml-form {\n  display: flex;\n  flex-direction: row !important;\n  /*     gap:2rem; */\n}\n\n.corsi-container {\n  background-color: #333;\n  height: calc(100% - 60px);\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.corsi-container .separator {\n  position: absolute;\n  width: 100%;\n  height: calc(100% - 60px);\n}\n.corsi-container .game-box {\n  width: 1000px;\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 2rem;\n  padding-top: 4rem;\n}\n.corsi-container .game-box .corsi-box {\n  border: 1px solid #fff;\n  width: 90px;\n  height: 90px;\n}\n.corsi-container .game-box .box-1 {\n  margin-left: 2rem;\n  margin-top: 8rem;\n}\n.corsi-container .game-box .box-2 {\n  margin-left: 2rem;\n}\n.corsi-container .game-box .box-3 {\n  margin-left: 4rem;\n  margin-top: 5rem;\n}\n.corsi-container .game-box .box-4 {\n  margin-left: 5rem;\n  margin-top: 7rem;\n}\n.corsi-container .game-box .box-5 {\n  margin-left: 5rem;\n  margin-top: 2rem;\n}\n.corsi-container .game-box .box-6 {\n  margin-left: 4rem;\n}\n.corsi-container .game-box .box-7 {\n  margin-left: 4rem;\n  margin-top: -4rem;\n}\n.corsi-container .game-box .box-8 {\n  margin-left: 4rem;\n  margin-top: -2rem;\n}\n.corsi-container .game-box .box-9 {\n  margin-left: 4rem;\n  margin-top: 3rem;\n}\n.corsi-container .game-box .box-10 {\n  margin-left: 4rem;\n  margin-top: -6rem;\n}\n@media (min-width: 1200px) {\n  .corsi-container .game-box {\n    gap: 2.5rem;\n  }\n}\n\n.switch-on {\n  border: 1px solid #4897be !important;\n  background-color: #4897be;\n}\n\n.hidden {\n  display: none;\n  visibility: hidden;\n}\n\n.corsi-options {\n  border: 1px solid #ccc;\n  align-self: center;\n}\n\n.corsi-start,\n.rotate-container {\n  transform: rotate(270deg);\n}\n\n.table-moments {\n  width: 60% !important;\n  margin: 0 auto;\n}\n.table-moments h2 {\n  padding: 2rem 0;\n}\n\n.hnf-container {\n    display: flex;\n    flex-direction: column;\n  }\n  .hnf-container .hnf-option-container {\n    display: flex;\n    border: 1px solid #ccc;\n    justify-content: space-between;\n    border-radius: 0.5rem;\n    margin: 2rem;\n    position: relative !important;\n  }\n  .hnf-container .hnf-box {\n    width: 50%;\n    height: 200px;\n    border-radius: 0.5rem;\n    background-color: #fff;\n    z-index: 2;\n  }\n  .hnf-container .hnf-button-container {\n    display: flex;\n    justify-content: space-around;\n    border-radius: 0.5rem;\n  }\n  .hnf-container .hnf-button-container .hnf-button {\n    width: 400px;\n    height: 250px;\n    border-radius: 0.5rem;\n    border: none;\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.4);\n    background-color: #f3f3f7;\n  }\n  .hnf-container .hnf-button-container .hnf-button:active {\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n  }\n  \n  .hnf-heart {\n    background-image: url(\"/public/images/corazon.png\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .hnf-flower {\n    background-image: url(\"/public/images/flower.png\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 10px;\n  }\n  \n  .hnf-instructions-1 {\n    position: absolute;\n    width: 100%;\n    height: 600px;\n    z-index: 10;\n    background-color: #fff;\n  }\n  .hnf-instructions-1 div h4 {\n    width: 80%;\n    margin: 2rem auto;\n    text-align: center;\n  }\n\n.plusOverlay {\n  background-color: #fff;\n  width: 300px !important;\n}\n\n.first-example {\n  background-image: url(\"/public/images/corazon-1.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 400px;\n  height: 250px;\n}\n\n.second-example {\n  background-image: url(\"/public/images/corazon-2.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 400px;\n  height: 250px;\n}\n\n.hnf-example-container {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 3rem;\n}\n\n.hidden-container {\n  z-index: 0;\n  display: none;\n  visibility: hidden;\n}\n\n#hnf-wall {\n  border: 2px solid red;\n  z-index: -1;\n  background-color: #ddd;\n}\n\n.overlay {\n  z-index: 2;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.container-hnf {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n\n.play-button {\n  cursor: pointer;\n}\n\n.active-option {\n  color: #fff;\n  background-color: #20c997;\n}\n\n.go-btn {\n  display: flex;\n  width: 90%;\n  margin: 0 auto;\n  margin-top: 14rem;\n  justify-content: center;\n}\n\n@media (max-height: 650px) {\n  p {\n    font-size: 0.95rem;\n  }\n  h2 {\n    font-size: 1.5rem !important;\n  }\n  .main-description {\n    font-size: 1.2rem;\n    padding: 0 !important;\n  }\n  #root .aside-menu a {\n    padding: 0;\n  }\n  .instruments-list div {\n    padding: 0;\n  }\n  .page-item img {\n    max-width: 500px;\n  }\n  .containerBox {\n    height: 300px !important;\n    width: 600px !important;\n  }\n  .containerBox > .landing-area > .piece-inside,\n  .containerBox > .landing-area > .piece-inside-countable,\n  .containerBox > .pieces-container > .piece {\n    width: 50px !important;\n    height: 50px !important;\n  }\n  .play-button {\n    width: 50px;\n    height: 50px;\n  }\n  .play-button img {\n    width: 50px !important;\n  }\n  .go-btn {\n    margin-top: 5.5rem;\n    margin-left: -12rem;\n  }\n  .title-answers {\n    font-size: 1rem;\n  }\n  .item-image-wally img {\n    max-width: 420px;\n  }\n  .item-image-eml img {\n    max-width: 420px;\n  }\n  .aces-page-item img {\n    width: 400px;\n  }\n  .column-instruction .instruction {\n    height: 350px;\n    width: 350px;\n    margin: -3rem;\n  }\n  .column-instruction .instruction p {\n    font-size: 1rem;\n  }\n  .corsi-container {\n    padding-top: 2rem;\n  }\n  .corsi-container .game-box {\n    padding: 1rem;\n    padding-top: 0;\n    gap: 2.5rem;\n  }\n  .hnf-button-container .hnf-button {\n    width: 350px !important;\n    height: 200px !important;\n    border-radius: 0.5rem;\n    border: none;\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.4);\n    background-color: #f3f3f7;\n  }\n}\n.thirdStick {\n  background-image: url(\"/public/images/stick.png\");\n  background-position: bottom;\n  background-repeat: no-repeat;\n  background-size: 30px 300px;\n}\n\n.secondStick {\n  background-image: url(\"/public/images/stick.png\");\n  background-position: bottom;\n  background-repeat: no-repeat;\n  background-size: 30px 210px;\n}\n\n.firstStick {\n  background-image: url(\"/public/images/stick.png\");\n  background-position: bottom;\n  background-repeat: no-repeat;\n  background-size: 30px 120px;\n}\n\n.esc-image {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  width: 600px; /* Need a specific value to work */\n}\n\n.esc-emotion {\n  width: 350px;\n  height: 200px;\n  box-sizing: border-box;\n}\n\n.esc-test {\n  display: flex;\n  flex-direction: column;\n}\n\n.esc-test:hover {\n  outline: 4px solid #3aafb9;\n}\n\n.esc-test:active {\n  outline: 4px solid #3aafb9;\n}\n\n.esc-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n\n.esc-form {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n@media (min-width: 1200px) {\n  .esc-emotion {\n    width: 500px;\n    height: 250px;\n    box-sizing: border-box;\n  }\n}\nhtml {\n  background-color: #fff;\n}\n\n.first-instrument {\n  height: 100%;\n}\n\nbody, html {\n  -webkit-touch-callout: none; /* Safari */\n  -webkit-user-select: none; /* Chrome */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\nimg {\n  pointer-events: none;\n}\n\n#root {\n  background-color: #fff;\n  height: 100vh;\n}\n\n.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before {\n  background-color: #fff !important;\n}\n\n.swiper {\n  height: 100%;\n  overflow: hidden;\n}\n\n.swiper-button-disabled {\n  visibility: hidden !important;\n}\n\n.swiper-button-next,\n.swiper-button-prev {\n  background-color: #3aafb9;\n  color: #fff !important;\n  width: 45px !important;\n  margin-top: 30vh !important;\n  padding: 1rem;\n  border-radius: 2rem;\n  -webkit-border-radius: 2rem;\n  -moz-border-radius: 2rem;\n  -ms-border-radius: 2rem;\n  -o-border-radius: 2rem;\n  box-shadow: 0px 5px 5px rgba(2, 2, 0, 0.35);\n}\n\n.swiper-button-next:active,\n.swiper-button-prev:active {\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n}\n\n.swiper-button-next {\n  margin-right: 3rem;\n}\n\n.swiper-button-prev {\n  margin-left: 3rem;\n}\n\n.swiper-scrollbar-drag {\n  background-color: #ff6838 !important;\n}\n\n/* Se supone esto ayuda para no recargar la pagina en celulares desplazando el dedo */\nbody {\n  overscroll-behavior-y: contain !important;\n}\n\n.button {\n  width: 120px;\n  margin: 0 auto;\n}\n\n.game-title {\n  text-align: center;\n  margin-top: 0.7rem;\n  color: #444;\n}\n\n.containerBox {\n  margin: 2rem;\n  width: 800px;\n  height: 500px;\n  margin: 2rem auto;\n  display: flex;\n  justify-content: center;\n}\n.containerBox .pieces-container {\n  width: 50%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  align-content: flex-start;\n  gap: 0.5rem;\n  padding: 0.2rem;\n}\n.containerBox .pieces-container .piece {\n  width: 70px;\n  height: 70px;\n  background-color: #FF5656;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);\n}\n.containerBox .landing-area {\n  width: 50%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  align-content: flex-start;\n  gap: 0.5rem;\n  padding: 0.2rem;\n  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.6);\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.containerBox .landing-area .piece-inside, .containerBox .landing-area .piece-inside-countable {\n  width: 70px;\n  height: 70px;\n  background-color: #FF5656;\n  border-radius: 50%;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n}\n\n.restart-button {\n  display: block;\n  width: 100px;\n  height: 40px;\n  color: #fff;\n  background-color: #3aafb9;\n  text-align: center;\n  margin: 0 auto;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n  border: none;\n  outline: none !important;\n}\n\n.quantification-value {\n  width: 70px;\n  padding: 0.5rem !important;\n}\n\n.swiper-scrollbar {\n  height: 1rem !important;\n}\n\n.swiper-wrapper {\n  height: calc(100vh - 120px) !important;\n}\n\n.btn-visibility {\n  width: 40px;\n  height: 40px;\n  outline: none;\n  border: none;\n  display: inline;\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  box-shadow: 0px 3px 3px rgba(2, 2, 0, 0.25);\n  background-color: inherit;\n  color: #3aafb9;\n}\n\n.image-instruction-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  position: relative;\n}\n\n.main-content-wrapper {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  align-content: center;\n  gap: 2rem;\n}\n.main-content-wrapper img {\n  max-width: 100%;\n  max-height: 500px;\n}\n.main-content-wrapper form {\n  width: 50%;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.quantification-counter {\n  display: flex;\n  align-items: baseline;\n  align-content: center;\n  justify-content: space-between;\n  width: 400px;\n  gap: 0.5rem;\n}\n.quantification-counter .form-check-label {\n  padding: 0;\n  margin: 0 1rem;\n  width: 70px !important;\n}\n\n.japi-container {\n  background-image: url(\"/public/images/japi-background.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 100%;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  gap: 10px;\n  flex-direction: column;\n}\n\n.japi-container-center {\n  background-image: url(\"/public/images/japi-background.jpg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 100%;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  gap: 10px;\n  flex-direction: column;\n  justify-content: center;\n}\n\n\n\n  \n/* --------------------------------------- STROOP NUMÉRICO --------------------------------------- */\n.stroopnum-black-section {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 100%;\n    background-color: black;\n    font-family: \"Times New Roman\", Times, serif;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.stroopnum-cross-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 1%;\n    height: 100px;\n    transform: translate(-50%, -45%);\n    z-index: 1; /* Asegúrate de que la cruz esté delante del contenido */\n}\n\n.stroopnum-cross {\n    position: absolute;\n    background-color: white;\n}\n\n.stroopnum-horizontal {\n    width: 100%;\n    height: 3px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.stroopnum-vertical {\n    width: 3px;\n    height: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n/* Contenedor principal */\n.stroopnum-container {\n    text-align: center;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Texto central */\n.stroopnum-central-text {\n    color: white;\n    font-size: 50px;\n    margin-bottom: 100px;\n}\n\n/* Estilos generales para los botones */\n.stroopnum-button-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* 2 columnas iguales */\n    grid-template-rows: repeat(2, 1fr); /* 2 filas iguales */\n    gap: 10px; /* Espacio entre los botones */\n    width: 300px; /* Ancho fijo para las grillas */\n    height: 300px; /* Alto fijo para las grillas */\n}\n\n/* Grilla inferior izquierda */\n.stroopnum-button-grid-left {\n    position: absolute;\n    bottom: 20px; /* Ajusta según sea necesario */\n    left: 100px; /* Ajusta según sea necesario */\n}\n\n/* Grilla inferior derecha */\n.stroopnum-button-grid-right {\n    position: absolute;\n    bottom: 20px; /* Ajusta según sea necesario */\n    right: 60px; /* Ajusta según sea necesario */\n}\n\n/* Botones redondos */\n.stroopnum-no-button {\n    background-color: black;\n    color: black;\n    border: none;\n    width: 100px;\n    height: 100px;\n}\n\n/* Botones redondos */\n.stroopnum-round-button {\n    background-color: white;\n    color: black;\n    border: none;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    font-size: 36px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.stroopnum-round-button.highlight{\n    border-color: blue;\n    background-color: #fffc61;\n}\n\n/* --------------------------------------- STROOP COLOR --------------------------------------- */\n.stroopcol-black-section {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 100%;\n    background-color: black;\n    font-family: \"Times New Roman\", Times, serif;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.stroopcol-cross-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100px;\n    height: 100px;\n    transform: translate(-50%, -45%);\n    z-index: 1; /* Asegúrate de que la cruz esté delante del contenido */\n}\n\n.stroopcol-cross {\n    position: absolute;\n    background-color: white;\n}\n\n.stroopcol-horizontal {\n    width: 100%;\n    height: 3px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.stroopcol-vertical {\n    width: 3px;\n    height: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n/* Contenedor principal */\n.stroopcol-container {\n    text-align: center;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Texto central */\n.stroopcol-central-text {\n    color: white;\n    font-size: 50px;\n    margin-bottom: 100px;\n}\n\n/* Estilos generales para los botones */\n.stroopcol-button-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* 2 columnas iguales */\n    grid-template-rows: repeat(2, 1fr); /* 2 filas iguales */\n    gap: 10px; /* Espacio entre los botones */\n    width: 300px; /* Ancho fijo para las grillas */\n    height: 300px; /* Alto fijo para las grillas */\n}\n\n/* Grilla inferior izquierda */\n.stroopcol-button-grid-left {\n    position: absolute;\n    bottom: 30px; /* Ajusta según sea necesario */\n    left: 100px; /* Ajusta según sea necesario */\n}\n\n/* Grilla inferior derecha */\n.stroopcol-button-grid-right {\n    position: absolute;\n    bottom: 30px; /* Ajusta según sea necesario */\n    right: 70px; /* Ajusta según sea necesario */\n}\n\n/* Botones redondos */\n.stroopcol-no-button {\n    background-color: black;\n    color: black;\n    border: none;\n    width: 100px;\n    height: 100px;\n}\n\n/* Botones redondos */\n.stroopcol-round-button {\n    background-color: white;\n    color: black;\n    border: 8px solid;\n    border-color: black;\n    border-radius: 50%;\n    width: 120px;\n    height: 120px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.stroopcol-round-button.highlight{\n    border-color: white;\n}\n\n/* --------------------------------------- CMASR --------------------------------------- */\n\n/* Contenedor principal */\n.cmasr-container {\n    display: flex;\n    flex-direction: column; /* Organiza los elementos verticalmente */\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #ffffff;\n    padding: 20px;\n}\n\n/* Contenedor de botones */\n.cmasr-button-container {\n    width: 60%;\n    display: flex;\n    justify-content: space-around;\n    position: absolute;\n    bottom: 140px;\n}\n\n/* Contenedor de la imagen */\n.cmasr-image-container {\n    position: center;\n    transform: translate(0%, -40%); /* Centra la imagen */\n}\n\n/* Imagen centrada */\n.cmasr-center-image {\n    width: 350px; /* Ajusta el tamaño de la imagen según sea necesario */\n    height: auto; /* Mantiene la proporción de la imagen */\n}\n\n/* Texto central en un rectángulo redondeado */\n.cmasr-central-text {\n    color: rgb(0, 0, 0);\n    font-family: \"Times New Roman\", Times, serif;\n    font-size: 28px;\n    margin-bottom: 150px;\n    background-color: #ffffff; /* Fondo blanco para el rectángulo */\n    padding-top: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */\n    padding-bottom: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */\n    padding-left: 100px;\n    padding-right: 100px;\n    border-radius: 12px; /* Grado de redondeo de las esquinas */\n    border: 2.25px solid #000000; /* Borde negro de 2px */\n    text-align: center; /* Centra el texto dentro del rectángulo */\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Sombra para darle un efecto de elevación */\n}\n\n\n/* Botones redondeados */\n.cmasr-round-button {\n    display: inline-block;\n    padding: 10px 20px;\n    background-color: #ffffff; /* Fondo blanco para el rectángulo */\n    font-family: \"Times New Roman\", Times, serif;\n    border-style: solid;\n    border-width: 2.25px;\n    border-radius: 8px;\n    text-align: center;\n    text-decoration: none;\n    font-size: 28px;\n    cursor: pointer;\n    width: 150px; /* Ancho fijo del botón */\n    height: 100px; /* Alto fijo del botón */\n    border-color: #000000; /* Color de borde predeterminado */\n    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */\n    color: #000; /* Color del texto predeterminado */\n}\n\n/* Estilo del botón activo (al presionar) */\n.cmasr-round-button.active {\n    border-color: blue; /* Color del borde cuando el botón está activo */\n    background-color: #ffffff; /* Fondo ligeramente gris para indicar presión */\n}\n\n.cmasr-round-button.highlight {\n    border-color: blue; /* Color del borde cuando el botón está activo */\n    background-color: #fffc61; /* Fondo ligeramente gris para indicar presión */\n}\n\n\n/* Botón redondo con imagen */\n.cmasr-top-right-button {\n    position: absolute;\n    top: 90px;\n    right: 30px;\n    width: 90px;\n    height: 90px;\n    border-radius: 50%; /* Redondear el botón */\n    background-color: #bfbfbf; /* Color de fondo del botón */\n    border-width: 4px;\n    border-color: #bfbfbf;\n    border-style: solid;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.cmasr-top-right-button.highlight {\n    border-color: blue; /* Color del borde cuando el botón está activo */\n    background-color: #fffc61; /* Fondo ligeramente gris para indicar presión */\n}\n\n.cmasr-top-right-button img {\n    width: 40px; /* Ajusta el tamaño de la imagen */\n    height: 40px;\n}\n\n.cmasr-bottom-right-button {\n    display: inline; /* Utiliza flexbox para alinear imagen y texto */\n    align-items: center; /* Centra verticalmente la imagen y el texto */\n    padding: 10px 0px; /* Espaciado interno del botón */\n    border-radius: 20px; /* Bordes redondeados */\n    border-style: solid;\n    border-width: 3px;\n    border-color: #ffffff; /* Bordes redondeados */\n    background-color: #ffffff; /* Color de fondo */\n    cursor: pointer; /* Cursor en forma de mano al pasar sobre el botón */\n    position: absolute;\n    bottom: 15px;\n    right: 0px;\n}\n\n.cmasr-bottom-right-button.highlight {\n    border-color: blue;\n    background-color: #fffc61;\n}\n\n.cmasr-arrow {\n    width: 70%;\n    height: auto;\n    object-fit: cover;\n}\n\n.cmasr-button-text {\n    position: absolute; /* Posiciona el texto en relación al botón */\n    top: 50%; /* Centra verticalmente el texto */\n    left: 60%; /* Centra horizontalmente el texto */\n    transform: translate(-80%, -50%); /* Ajusta la posición para centrar completamente */\n    color: rgb(0, 0, 0); /* Color del texto */\n    font-size: 20px; /* Tamaño de la fuente */\n    font-weight: bold; /* Negrita */\n    pointer-events: none; /* Evita que el texto interfiera con el clic en el botón */\n}\n\n/* --------------------------------------- AUTOCONCEPTO --------------------------------------- */\n\n/* Contenedor principal */\n.autocon-container {\n    display: flex;\n    flex-direction: column; /* Organiza los elementos verticalmente */\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #ffffff;\n    padding: 20px;\n}\n\n/* Contenedor de botones */\n.autocon-button-container {\n    width: 70%;\n    display: flex;\n    justify-content: space-around;\n    position: absolute;\n    bottom: 200px;\n}\n\n/* Contenedor de la imagen */\n.autocon-image-container {\n    position: center;\n    transform: translate(0%, -40%); /* Centra la imagen */\n}\n\n/* Imagen centrada */\n.autocon-center-image {\n    width: 350px; /* Ajusta el tamaño de la imagen según sea necesario */\n    height: auto; /* Mantiene la proporción de la imagen */\n}\n\n/* Texto central en un rectángulo redondeado */\n.autocon-central-text {\n    color: rgb(0, 0, 0);\n    font-family: \"Times New Roman\", Times, serif;\n    font-size: 28px;\n    margin-bottom: 230px;\n    background-color: #ffffff; /* Fondo blanco para el rectángulo */\n    padding-top: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */\n    padding-bottom: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */\n    padding-left: 100px;\n    padding-right: 100px;\n    border-radius: 12px; /* Grado de redondeo de las esquinas */\n    border: 2.25px solid #000000; /* Borde negro de 2px */\n    text-align: center; /* Centra el texto dentro del rectángulo */\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); /* Sombra para darle un efecto de elevación */\n}\n\n\n/* Botones redondeados */\n.autocon-round-button {\n    display: flex; /* Cambiado de inline-block a flex */\n    flex-direction: column; /* Asegura que el contenido esté en columna */\n    justify-content: center; /* Centra verticalmente el contenido */\n    align-items: center; /* Centra horizontalmente el contenido */\n    padding: 10px 20px;\n    background-color: #ffffff; /* Fondo blanco para el rectángulo */\n    font-family: \"Times New Roman\", Times, serif;\n    border-style: solid;\n    border-width: 2.25px;\n    border-radius: 15px;\n    text-align: center;\n    text-decoration: none;\n    font-size: 28px;\n    cursor: pointer;\n    width: 170px; /* Ancho fijo del botón */\n    height: 100px; /* Alto fijo del botón */\n    border-color: #000000; /* Color de borde predeterminado */\n    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */\n    color: #000; /* Color del texto predeterminado */\n}\n\n/* Estilo del texto en negrita */\n.autocon-round-button .text-bold {\n    font-weight: bold;\n    font-size: 24px;\n}\n\n/* Estilo del texto normal */\n.autocon-round-button .text-normal {\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 1;\n}\n\n.autocon-round-button.highlight {\n    border-color: blue;\n    background-color: #fffc61;\n}\n\n/* Estilo del botón activo (al presionar) */\n.autocon-round-button.active {\n    border-color: blue; /* Color del borde cuando el botón está activo */\n    background-color: #ffffff; /* Fondo ligeramente gris para indicar presión */\n}\n\n.autocon-bottom-right-button {\n    display: inline; /* Utiliza flexbox para alinear imagen y texto */\n    align-items: center; /* Centra verticalmente la imagen y el texto */\n    padding: 10px 0px; /* Espaciado interno del botón */\n    border-radius: 20px; /* Bordes redondeados */\n    border-style: solid;\n    border-width: 3px;\n    border-color: #ffffff; /* Bordes redondeados */\n    background-color: #ffffff; /* Color de fondo */\n    cursor: pointer; /* Cursor en forma de mano al pasar sobre el botón */\n    position: absolute;\n    bottom: 15px;\n    right: 0px;\n}\n\n.autocon-bottom-right-button.highlight {\n    border-color: blue;\n    background-color: #fffc61;\n}\n\n.autocon-arrow {\n    width: 70%;\n    height: auto;\n    object-fit: cover;\n}\n\n.autocon-button-text {\n    position: absolute; /* Posiciona el texto en relación al botón */\n    top: 50%; /* Centra verticalmente el texto */\n    left: 60%; /* Centra horizontalmente el texto */\n    transform: translate(-80%, -50%); /* Ajusta la posición para centrar completamente */\n    color: rgb(0, 0, 0); /* Color del texto */\n    font-size: 20px; /* Tamaño de la fuente */\n    font-weight: bold; /* Negrita */\n    pointer-events: none; /* Evita que el texto interfiera con el clic en el botón */\n}\n\n/* --------------------------------------- ACT.MAT --------------------------------------- */\n\n/* Contenedor principal */\n.actmat-container {\n    display: flex;\n    flex-direction: column; /* Organiza los elementos verticalmente */\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #ffffff;\n    padding: 20px;\n}\n\n/* Contenedor de botones */\n.actmat-button-container {\n    width: 60%;\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    bottom: 200px;\n}\n\n/* Contenedor de la imagen */\n.actmat-image-container {\n    position: center;\n    transform: translate(0%, -40%); /* Centra la imagen */\n}\n\n/* Imagen centrada */\n.actmat-center-image {\n    width: 350px; /* Ajusta el tamaño de la imagen según sea necesario */\n    height: auto; /* Mantiene la proporción de la imagen */\n}\n\n/* Texto central en un rectángulo redondeado */\n.actmat-central-text {\n    color: rgb(0, 0, 0);\n    font-family: \"Times New Roman\", Times, serif;\n    font-size: 40px;\n    margin-bottom: 230px;\n    background-color: #ffffff; /* Fondo blanco para el rectángulo */\n    padding-top: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */\n    padding-bottom: 40px; /* Espaciado interno para crear el rectángulo alrededor del texto */\n    padding-left: 100px;\n    padding-right: 100px;\n    text-align: center; /* Centra el texto dentro del rectángulo */\n}\n\n.actmat-label {\n    display: flex; /* Cambiado de inline-block a flex */\n    flex-direction: column; /* Asegura que el contenido esté en columna */\n    justify-content: center; /* Centra verticalmente el contenido */\n    align-items: center; /* Centra horizontalmente el contenido */\n    padding: 10px 20px;\n    background-color: #ffffff; /* Fondo blanco para el rectángulo */\n    font-family: \"Times New Roman\", Times, serif;\n    border-width: 0px;\n    text-align: center;\n    text-decoration: none;\n    font-size: 24px;\n    font-weight: bold;\n    cursor: pointer;\n    width: auto; /* Ancho fijo del botón */\n    height: auto; /* Alto fijo del botón */\n    border-color: #000000; /* Color de borde predeterminado */\n    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */\n    color: #000; /* Color del texto predeterminado */\n}\n\n/* Botones */\n.actmat-button {\n    display: flex; /* Cambiado de inline-block a flex */\n    flex-direction: column; /* Asegura que el contenido esté en columna */\n    justify-content: center; /* Centra verticalmente el contenido */\n    align-items: center; /* Centra horizontalmente el contenido */\n    padding: 0px 40px;\n    background-color: #ffffff; /* Fondo blanco para el rectángulo */\n    font-family: \"Times New Roman\", Times, serif;\n    border-style: solid;\n    border-width: 3px 1.5px;\n    text-align: center;\n    text-decoration: none;\n    font-size: 28px;\n    cursor: pointer;\n    width: auto; /* Ancho fijo del botón */\n    height: auto; /* Alto fijo del botón */\n    border-color: #000000; /* Color de borde predeterminado */\n    transition: border-color 0.3s ease; /* Transición suave para el cambio de color */\n    color: #000; /* Color del texto predeterminado */\n}\n\n.actmat-button.highlight {\n    border-color: blue;\n    background-color: #fffc61;\n}\n\n/* Estilo del botón activo (al presionar) */\n.actmat-button.active {\n    border-color: blue; /* Color del borde cuando el botón está activo */\n    background-color: #ffffff; /* Fondo ligeramente gris para indicar presión */\n}\n\n.actmat-bottom-right-button {\n    display: inline; /* Utiliza flexbox para alinear imagen y texto */\n    align-items: center; /* Centra verticalmente la imagen y el texto */\n    padding: 10px 0px; /* Espaciado interno del botón */\n    border-radius: 20px; /* Bordes redondeados */\n    border-style: solid;\n    border-width: 3px;\n    border-color: #ffffff; /* Bordes redondeados */\n    background-color: #ffffff; /* Color de fondo */\n    cursor: pointer; /* Cursor en forma de mano al pasar sobre el botón */\n    position: absolute;\n    bottom: 15px;\n    right: 0px;\n}\n\n.actmat-bottom-right-button.highlight {\n    border-color: blue;\n    background-color: #fffc61;\n}\n\n.actmat-arrow {\n    width: 70%;\n    height: auto;\n    object-fit: cover;\n}\n\n.actmat-button-text {\n    position: absolute; /* Posiciona el texto en relación al botón */\n    top: 50%; /* Centra verticalmente el texto */\n    left: 60%; /* Centra horizontalmente el texto */\n    transform: translate(-80%, -50%); /* Ajusta la posición para centrar completamente */\n    color: rgb(0, 0, 0); /* Color del texto */\n    font-size: 20px; /* Tamaño de la fuente */\n    font-weight: bold; /* Negrita */\n    pointer-events: none; /* Evita que el texto interfiera con el clic en el botón */\n}\n\n/* --------------------------------------- LISTENING SPAN --------------------------------------- */\n.listspan-black-section {\n    margin: 0;\n    padding: 0;\n    height: 100vh; /* Utiliza toda la altura de la ventana */\n    width: 100vw; /* Utiliza toda la anchura de la ventana */\n    background-color: black;\n    font-family: \"Times New Roman\", Times, serif;\n    display: flex;\n    flex-direction: column;\n    justify-content: center; /* Centra verticalmente el contenido */\n    align-items: center; /* Centra horizontalmente el contenido */\n    overflow: hidden; /* Evita barras de desplazamiento */\n}\n\n/* Contenedor principal */\n.listspan-container {\n    text-align: center;\n    width: 100%; /* Ajustado al 100% para ocupar el espacio completo */\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.listspan-text-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh; /* El contenedor ocupará toda la pantalla */\n    width: 100vw;  /* El ancho del contenedor será el 100% de la pantalla */\n    text-align: center;\n}\n\n.listspan-central-text {\n    color: rgb(255, 255, 255);\n    font-family: \"Times New Roman\", Times, serif;\n    font-size: 50px;\n    background-color: transparent;\n    text-align: center;\n}\n\n/* Ajustar el contenedor de la imagen para centrarlo correctamente */\n.listspan-image-container {\n    padding-top: 1rem; /* Ajusta el espacio superior */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n/* Ajustar el tamaño de la imagen */\n.listspan-center-image {\n    width: 100px;\n    height: auto;\n    max-width: 100%;\n}\n\n/* Botones debajo de la imagen */\n.listspan-buttons-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 60px;\n    width: 100%;\n}\n\n/* Estilos de los botones */\n.listspan-button {\n    padding: 10px 20px;\n    margin: 0 6%; /* Ajusta el espacio entre los botones */\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 32px;\n    font-weight: bold;\n    width: 200px;\n    height: 75px;\n}\n\n/* Estilo para la grilla de botones */\n.listspan-grid-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr); /* 3 columnas para un total de 12 botones */\n    grid-gap: 20px 70px; /* Espacio entre los elementos de la grilla */\n}\n\n/* Estilo para cada ítem de la grilla */\n.listspan-grid-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.listspan-grid-button {\n    font-size: 20px;\n    width: 70px;\n    height: 36px;\n    font-weight: bold;\n}\n\n.listspan-grid-button:disabled {\n    background-color: white;\n    color: black;\n}\n\n.listspan-grid-text {\n    color: white;\n    font-size: 28px;\n}\n\n/* Texto debajo de la grilla */\n.listspan-info-text {\n    font-size: 28px;\n    font-weight: bold;\n    color: white; /* Ajusta el color según tu diseño */\n    margin: 40px;\n    height: 30px;\n}\n\n/* Botones adicionales debajo del texto */\n.listspan-additional-buttons {\n    display: flex;\n    gap: 60px; /* Espacio entre los botones */\n    margin-bottom: 60px;\n}\n\n.listspan-additional-button {\n    padding: 10px 20px;\n    font-size: 20px;\n    width: 120px;\n    cursor: pointer;\n    border-radius: 50px;\n}\n\n/* --------------------------------------- COUNTING SPAN --------------------------------------- */\n/* Contenedor principal */\n.countspan-centered-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh; /* Asegura que el contenedor ocupe toda la pantalla */\n}\n\n/* Contenedor de la imagen */\n.countspan-image-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 650px; /* Limita el ancho máximo de la imagen */\n    margin-bottom: 10px;\n}\n\n/* Imagen que se adapta a la pantalla */\n.countspan-image {\n    max-width: 100%; /* La imagen no excede el ancho del contenedor */\n    height: auto; /* Mantiene las proporciones de la imagen */\n    max-height: 80vh; /* Asegura que la imagen no sea demasiado alta */\n}\n\n/* Contenedor de los botones */\n.countspan-button-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Fila de botones */\n.countspan-button-row {\n    display: flex;\n    justify-content: center;\n}\n\n/* Botones numerados */\n.countspan-number-button {\n    padding: 10px 20px;\n    margin: 5px;\n    background-color: #fff;\n    border: 1px solid #000000;\n    border-radius: 5px;\n    font-size: 26px;\n    font-family: 'Times New Roman';\n    cursor: pointer;\n    width: 60px;\n    height: 60px;\n}\n\n/* Estilo del botón activo (al presionar) */\n.countspan-number-button.active {\n    border: 2px solid blue; /* Color del borde cuando el botón está activo */\n    background-color: #eca649; /* Fondo ligeramente gris para indicar presión */\n    color: black;\n    font-weight: bold;\n}\n\n\n.countspan-number-button:disabled {\n    /* background-color: white; */\n    color: black;\n}",".header {\n    background-color:#1674d8;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-content: baseline;\n\n    .selb-icon-wrapper{ \n        font-family: 'Kanit', sans-serif;\n        color:#fff;\n        font-weight: 800;\n        letter-spacing: 1px;\n        \n        display: flex;\n        align-items: center;\n        align-content: center;\n        justify-content: space-evenly;\n        gap:1.5rem;\n\n        #refresh-icon {\n            width:30px;\n            cursor: pointer;\n        }\n\n        h4 {\n            margin-right:2rem;\n            margin-bottom:0;\n        }\n        \n    }\n\n\n}\n\n\n.header-japi {\n    background-color:#fff;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-content: baseline;\n    position:sticky;\n\n    .japi-icon-wrapper{ \n        font-family: 'Kanit', sans-serif;\n        color:rgb(56, 163, 165);\n        font-weight: 800;\n        letter-spacing: 1px;\n        \n        display: flex;\n        align-items: center;\n        align-content: center;\n        justify-content: space-evenly;\n        gap:1.5rem;\n\n        #refresh-icon {\n            width:30px;\n            cursor: pointer;\n        }\n\n        h4 {\n            margin-right:2rem;\n            margin-bottom:0;\n        }\n        \n    }\n\n\n}",".aside-bar {\n    background-color: #fff;\n    width:100%;\n    display:flex;\n    align-items: center;\n    align-content: center;\n    flex-direction: column;\n    width:220px;\n    margin-top:1rem;\n    padding:.5rem;\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);\n    position:fixed;\n    z-index:10;\n    border-radius:1rem ;\n    -webkit-border-radius:1rem ;\n    -moz-border-radius:1rem ;\n    -ms-border-radius:1rem ;\n    -o-border-radius:1rem ;\n    \n    a{\n        text-decoration: none;\n        color:#333;\n        padding:.5rem 1rem;\n        margin:.5rem 0;\n        border-radius:.8rem;\n        -webkit-border-radius:.8rem;\n        -moz-border-radius:.8rem;\n        -ms-border-radius:.8rem;\n        -o-border-radius:.8rem;\n        cursor: pointer;\n}\n\n    a:hover {\n        background-color:#7ebdc2;\n        color:#fff !important;\n    }\n\n    .aside-head {\n        display:block;\n        width:80%;\n        border-bottom:1px solid #284b63;\n        padding:1rem 0;\n    }\n\n    .aside-menu {\n        display:flex;\n        flex-direction: column;\n        padding:1rem 0;\n        width:80%;\n\n\n\n    }\n\n\n\n\n}\n\n.aside-bar-hidden {\n    transform:translate(-100%);\n    -webkit-transform:translate(-100%);\n    -moz-transform:translate(-100%);\n    -ms-transform:translate(-100%);\n    -o-transform:translate(-100%);\n    transition:.5s ease-in;\n    -webkit-transition:.5s ease-in;\n    -moz-transition:.5s ease-in;\n    -ms-transition:.5s ease-in;\n    -o-transition:.5s ease-in;\n}\n\n.aside-bar-active {\n    z-index:9999;\n    transform:translate(0%);\n    -webkit-transform:translate(0%);\n    -moz-transform:translate(0%);\n    -ms-transform:translate(0%);\n    -o-transform:translate(0%);\n    transition: translate .5s ease in;\n    -webkit-transition: translate .5s ease in;\n    -moz-transition: translate .5s ease in;\n    -ms-transition: translate .5s ease in;\n    -o-transition: translate .5s ease in;\n}\n\n.active {\n    color:#fff;\n    font-weight: bold;\n}\n\n.profile-picture-wrapper {\n    margin-bottom:1rem;\n    overflow: hidden;\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    border:1px solid #ccc;\n\n    img {\n        width:60px;\n    }\n}\n\n#home-icon, #students-icon, #users-icon, #logout-icon, #excel-icon, #parents-icon, #moment-icon, #development-icon {\n    width:20px;\n    margin-bottom:3px;\n    margin-right:4px;\n}\n","/* .login {\n    background-color:rgb(200, 217, 231);\n    margin:3rem auto;\n    width:50%;\n    max-width:600px;\n    min-width:250px;\n    border-radius:.5rem;\n    -webkit-border-radius:.5rem;\n    -moz-border-radius:.5rem;\n    -ms-border-radius:.5rem;\n    -o-border-radius:.5rem;\n\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    padding:2rem;\n\n    #loginForm {\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        align-content: center;\n        gap:.5rem;\n\n        img {\n            width:50%;\n        }\n\n        input {\n            width:70%;\n            min-width:200px;\n            max-width:450px;\n            padding:.5rem;\n            background-color:#fff;\n            border:1px solid #ddd;\n            border-radius:.5rem;        ;\n            -webkit-border-radius:.5rem        ;\n            -moz-border-radius:.5rem        ;\n            -ms-border-radius:.5rem        ;\n            -o-border-radius:.5rem        ;\n}\n        \n    }\n} */\n\n.signin {\n    margin:0;\n    height:95vh;;\n    width:100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    .signin-form {\n        border:1px solid #ccc;\n        width:70%;\n        max-width:1000px;\n        min-width:300px;\n\n        display:flex;\n\n        flex-direction: column;\n        justify-content: center;\n        padding:6rem 2rem;\n        background-color:#fff;\n        border-radius:.5rem ;\n        -webkit-border-radius:.5rem ;\n        -moz-border-radius:.5rem ;\n        -ms-border-radius:.5rem ;\n        -o-border-radius:.5rem ;\n\n\n        img{\n            width:50%;\n            max-width: 200px;\n            margin:0 auto;\n            padding:0;\n            line-height:0;\n        }\n\n        .signin-title {\n            color:#fff;\n            text-align:center;\n        }\n        label {\n            color:#fff;\n           \n        }\n        input {\n            margin:.4rem auto;\n            width:40%;\n\n            min-width:200px;\n            max-width:400px;\n            border:none;\n            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);\n            background-color: #fff;\n            padding:.4rem;\n        \n        }\n\n\n\n        #signin-button {\n            display:inline;\n            margin:0 auto;\n            padding:.4rem;\n            width:100px;\n            margin-top:.4rem;\n        }\n\n        .signin-title {\n            color:#444;\n        }\n\n\n\n\n    \n    }\n}\n","/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\n html {\n    line-height: 1.15; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n  }\n  \n  /* Sections\n     ========================================================================== */\n  \n  /**\n   * Remove the margin in all browsers.\n   */\n  \n  body {\n    margin: 0;\n  }\n  \n  /**\n   * Render the `main` element consistently in IE.\n   */\n  \n  main {\n    display: block;\n  }\n  \n  /**\n   * Correct the font size and margin on `h1` elements within `section` and\n   * `article` contexts in Chrome, Firefox, and Safari.\n   */\n  \n  h1 {\n    font-size: 2em;\n\n  }\n  \n  /* Grouping content\n     ========================================================================== */\n  \n  /**\n   * 1. Add the correct box sizing in Firefox.\n   * 2. Show the overflow in Edge and IE.\n   */\n  \n  hr {\n    box-sizing: content-box; /* 1 */\n    height: 0; /* 1 */\n    overflow: visible; /* 2 */\n  }\n  \n  /**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n  \n  pre {\n    font-family: monospace, monospace; /* 1 */\n    font-size: 1em; /* 2 */\n  }\n  \n  /* Text-level semantics\n     ========================================================================== */\n  \n  /**\n   * Remove the gray background on active links in IE 10.\n   */\n  \n  a {\n    background-color: transparent;\n  }\n  \n  /**\n   * 1. Remove the bottom border in Chrome 57-\n   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n   */\n  \n  abbr[title] {\n    border-bottom: none; /* 1 */\n    text-decoration: underline; /* 2 */\n    text-decoration: underline dotted; /* 2 */\n  }\n  \n  /**\n   * Add the correct font weight in Chrome, Edge, and Safari.\n   */\n  \n  b,\n  strong {\n    font-weight: bolder;\n  }\n  \n  /**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n  \n  code,\n  kbd,\n  samp {\n    font-family: monospace, monospace; /* 1 */\n    font-size: 1em; /* 2 */\n  }\n  \n  /**\n   * Add the correct font size in all browsers.\n   */\n  \n  small {\n    font-size: 80%;\n  }\n  \n  /**\n   * Prevent `sub` and `sup` elements from affecting the line height in\n   * all browsers.\n   */\n  \n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  \n  sub {\n    bottom: -0.25em;\n  }\n  \n  sup {\n    top: -0.5em;\n  }\n  \n  /* Embedded content\n     ========================================================================== */\n  \n  /**\n   * Remove the border on images inside links in IE 10.\n   */\n  \n  img {\n    border-style: none;\n  }\n  \n  /* Forms\n     ========================================================================== */\n  \n  /**\n   * 1. Change the font styles in all browsers.\n   * 2. Remove the margin in Firefox and Safari.\n   */\n  \n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit; /* 1 */\n    font-size: 100%; /* 1 */\n    line-height: 1.15; /* 1 */\n    margin: 0; /* 2 */\n  }\n  \n  /**\n   * Show the overflow in IE.\n   * 1. Show the overflow in Edge.\n   */\n  \n  button,\n  input { /* 1 */\n    overflow: visible;\n  }\n  \n  /**\n   * Remove the inheritance of text transform in Edge, Firefox, and IE.\n   * 1. Remove the inheritance of text transform in Firefox.\n   */\n  \n  button,\n  select { /* 1 */\n    text-transform: none;\n  }\n  \n  /**\n   * Correct the inability to style clickable types in iOS and Safari.\n   */\n  \n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    -webkit-appearance: button;\n  }\n  \n  /**\n   * Remove the inner border and padding in Firefox.\n   */\n  \n  button::-moz-focus-inner,\n  [type=\"button\"]::-moz-focus-inner,\n  [type=\"reset\"]::-moz-focus-inner,\n  [type=\"submit\"]::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  \n  /**\n   * Restore the focus styles unset by the previous rule.\n   */\n  \n  button:-moz-focusring,\n  [type=\"button\"]:-moz-focusring,\n  [type=\"reset\"]:-moz-focusring,\n  [type=\"submit\"]:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n  \n  /**\n   * Correct the padding in Firefox.\n   */\n  \n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  \n  /**\n   * 1. Correct the text wrapping in Edge and IE.\n   * 2. Correct the color inheritance from `fieldset` elements in IE.\n   * 3. Remove the padding so developers are not caught out when they zero out\n   *    `fieldset` elements in all browsers.\n   */\n  \n  legend {\n    box-sizing: border-box; /* 1 */\n    color: inherit; /* 2 */\n    display: table; /* 1 */\n    max-width: 100%; /* 1 */\n    padding: 0; /* 3 */\n    white-space: normal; /* 1 */\n  }\n  \n  /**\n   * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n   */\n  \n  progress {\n    vertical-align: baseline;\n  }\n  \n  /**\n   * Remove the default vertical scrollbar in IE 10+.\n   */\n  \n  textarea {\n    overflow: auto;\n  }\n  \n  /**\n   * 1. Add the correct box sizing in IE 10.\n   * 2. Remove the padding in IE 10.\n   */\n  \n  [type=\"checkbox\"],\n  [type=\"radio\"] {\n    box-sizing: border-box; /* 1 */\n    padding: 0; /* 2 */\n  }\n  \n  /**\n   * Correct the cursor style of increment and decrement buttons in Chrome.\n   */\n  \n  [type=\"number\"]::-webkit-inner-spin-button,\n  [type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n  }\n  \n  /**\n   * 1. Correct the odd appearance in Chrome and Safari.\n   * 2. Correct the outline style in Safari.\n   */\n  \n  [type=\"search\"] {\n    -webkit-appearance: textfield; /* 1 */\n    outline-offset: -2px; /* 2 */\n  }\n  \n  /**\n   * Remove the inner padding in Chrome and Safari on macOS.\n   */\n  \n  [type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  \n  /**\n   * 1. Correct the inability to style clickable types in iOS and Safari.\n   * 2. Change font properties to `inherit` in Safari.\n   */\n  \n  ::-webkit-file-upload-button {\n    -webkit-appearance: button; /* 1 */\n    font: inherit; /* 2 */\n  }\n  \n  /* Interactive\n     ========================================================================== */\n  \n  /*\n   * Add the correct display in Edge, IE 10+, and Firefox.\n   */\n  \n  details {\n    display: block;\n  }\n  \n  /*\n   * Add the correct display in all browsers.\n   */\n  \n  summary {\n    display: list-item;\n  }\n  \n  /* Misc\n     ========================================================================== */\n  \n  /**\n   * Add the correct display in IE 10+.\n   */\n  \n  template {\n    display: none;\n  }\n  \n  /**\n   * Add the correct display in IE 10.\n   */\n  \n  [hidden] {\n    display: none;\n  }",".home-wrapper {\n\n    \n\n    text-align: center;\n\n    h1 {\n        padding:2rem;\n        color:#444;\n        text-align: center;\n\n        height:100%;\n        \n    }\n\n    h4 {\n        color:#444;\n\n    }\n\n    display:flex;\n    flex-direction: column;\n    gap:.5rem;\n\n    .table-wrapper {\n        display: flex;\n        justify-content: space-evenly;\n        align-items: baseline;\n        align-content: center;\n        flex-wrap: wrap;\n    }\n}\n\n.table-home {\n    width:300px !important;\n    margin:2rem auto;\n    border:1px solid #444;\n    color:#333;\n\n}\n\n.selb-info {\n    cursor:pointer;\n}",".kid-icon {\n    width:30px;\n}\n\n.genre {\n    text-align: center;\n}\n\n.listed-student {\n    background-color:#fff;\n    cursor: pointer;\n}\n\n.listed-student:hover {\n    background-color: #3AAFB9;\n    color:#fff;\n\n}\n\n.student-list-wrapper {\n    min-width:300px;\n    width:95%;\n    margin:1rem auto;\n    border-radius: .4rem;\n    -webkit-border-radius: .4rem;\n    -moz-border-radius: .4rem;\n    -ms-border-radius: .4rem;\n    -o-border-radius: .4rem;\n    border:1px solid #ccc;\n    padding:1rem;\n\n\n\n    select {\n        width:300px;\n        margin:0 auto;\n    }\n}","#instruments-list-wrapper {\n    width:100%;\n    height:100vh;\n    background: rgba(244, 244, 244, 0.5);\n    position:fixed;\n    top:0;\n    left:0;\n    \n    #instruments-list {\n        position:fixed;\n        width:700px;\n        height:500px;\n        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);\n        background-color: #fff;\n        margin: auto;\n        top:0;\n        left:0;\n        right:0;\n        bottom:0;\n        border-radius:.8rem ;\n        padding:1.2rem;\n        display:grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap:1rem;\n        align-items: start;\n        align-content: flex-start;\n        z-index:20; \n    \n        \n        h4{\n            width:100%;\n            text-align: center;\n            border-radius:inherit;\n            padding:inherit;\n            color:#3aafb9;\n            font-weight: bold;\n            margin:0;\n            font-family: 'Kanit', sans-serif;\n            letter-spacing: 1px;\n        }\n    \n        .listed-instrument {\n            width:100%;\n            cursor: pointer;\n            border-radius: .4rem;\n            font-weight: bold;\n            color:#555;\n            padding:0;\n    }\n    \n        .listed-instrument:hover {\n            background-color:#3aafb9;\n            color:#fff;\n        }\n    }\n}\n\n\n\n\n\n.active {\n    display:block;\n    opacity:1;\n    transition: opacity 1s ease;\n    -webkit-transition: opacity 1s ease;\n    -moz-transition: opacity 1s ease;\n    -ms-transition: opacity 1s ease;\n    -o-transition: opacity 1s ease;\n}\n\n\n.hidden {\n    display: none;\n    opacity:0;\n    transition: opacity 1s ease ;\n    -webkit-transition: opacity 1s ease ;\n    -moz-transition: opacity 1s ease ;\n    -ms-transition: opacity 1s ease ;\n    -o-transition: opacity 1s ease ;\n}\n\n\n#instrument-icon {\n    width:30px;\n    margin-bottom:1px;\n    margin-right:4px;\n}",".page-item {\n    background-color: #fff;\n    height:calc(100vh - 120px);\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    margin: auto;\n\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    text-align: center;\n\n    .letter-example {\n        width:80%;\n        margin:0 auto;\n    }\n\n    .main-description {\n        width:60%;\n        line-height:2rem;\n        min-width:300px;\n        margin:0 auto;\n        background-color: transparent;\n        padding:2rem;\n        border-radius: .5rem;\n        -webkit-border-radius: .5rem;\n        -moz-border-radius: .5rem;\n        -ms-border-radius: .5rem;\n        -o-border-radius: .5rem;\n    }\n\n    form {\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        align-items: flex-start;\n        padding:2rem;\n\n    }\n\n    img {\n        max-width:600px;\n    }\n\n}\n/* First Instrument */\n\n.instrument-form{\n        \n        text-align: start;\n        input,label {\n            padding:.6rem;\n        }\n\n\n        label  {\n            cursor: pointer;\n            width:100%;\n            border-radius: .5rem;\n            -webkit-border-radius: .5rem;\n            -moz-border-radius: .5rem;\n            -ms-border-radius: .5rem;\n            -o-border-radius: .5rem;\n\n        }\n\n        label:hover {\n            background-color: #3aafb9;\n            color:#fff;\n        }\n\n        label > input[type=\"radio\"] {\n            margin-right:5px;\n        }\n\n        padding:1rem !important;\n}\n\n.sdq-wrapper {\n    max-width: 1100px;\n    margin:1rem auto;\n    padding:2rem 0;\n    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.25);\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n\n\n    .sdq-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-around;\n        width:inherit;\n        padding:2rem 0;\n\n        img {\n            width:40%;\n        }\n\n        \n    }\n\n\n\n    .sdq-instructions {\n\n        border:1px solid #ccc;\n\n        h6 {\n            width:100%;\n            background-color: #ccc;\n            padding:.5rem;\n        }\n        width:90%;\n        margin:0 auto;\n\n        p {\n            padding:1rem;\n        }\n\n    \n\n    }\n\n    #sdq-btn {\n        width:150px;\n\n    }\n}\n.instrument-sdq {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    border:1px solid #ddd;\n    width:90%;\n    margin: 1rem auto;\n    \n\n    .sdq-title {\n        width:40%;\n        text-align: start;\n    }\n\n    .sdq-option {\n        width:60%;\n\n        label {\n            margin-left:20px;\n            padding:0rem;\n        }\n\n    }\n\n}\n\n\n.instrument-sdq__open {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 1rem auto;\n    width: 90%;\n    \n    h6 {\n        align-self: flex-start;\n    }\n\n    textarea {\n        align-self: flex-start;\n        width:1000px;\n        text-align: start;\n        padding:1rem;\n        max-height:200px;\n    }\n}\n\n\n.instrument-multiple {\n\n    max-width:900px;\n    margin-bottom:1rem;\n}\n\n.multipleChoicesWrapper {\n    border:1px solid #ddd;\n    width:90%;\n    margin: 1rem auto;\n\n}\n\n.instrument-sdq__extended {\n    display: flex;\n\n    border:1px solid #ddd;\n    margin: 1rem auto;\n    width: 90%;\n    flex-direction: column;\n\n    .sdq-option {\n        text-align: center;\n    }\n}\n\n\n\n.aces-item {\n    width:100px !important;\n    height:100px !important;\n}",".book-wrapper {\n    width:98%;\n    margin-left:1rem;\n    margin-right:1rem;\n    padding:1rem;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 1);\n    border-radius:.5rem     ;\n    -webkit-border-radius:.5rem     ;\n    -moz-border-radius:.5rem     ;\n    -ms-border-radius:.5rem     ;\n    -o-border-radius:.5rem     ;\n    background-color: #CED4AC;\n    .demopage {\n        width:100%;\n        border-radius:inherit;\n        -webkit-border-radius:inherit;\n        -moz-border-radius:inherit;\n        -ms-border-radius:inherit;\n        -o-border-radius:inherit;\n}\n\n\n    .stf__block {\n        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.8);\n        border-radius:.5rem    ;\n        -webkit-border-radius:.5rem    ;\n        -moz-border-radius:.5rem    ;\n        -ms-border-radius:.5rem    ;\n        -o-border-radius:.5rem    ;\n}\n\nimg {\n    max-width:100%;\n}\n\n}",".instruction {\n    background-color: #3AAFB9;\n    color:#fff;\n    padding:2rem;\n    border-radius: .5rem;\n    -webkit-border-radius: .5rem;\n    -moz-border-radius: .5rem;\n    -ms-border-radius: .5rem;\n    -o-border-radius: .5rem;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);\n}\n\n.statement {\n\n    color:#444;\n    padding:2rem;\n}\n\n.statement-instruction {\n    \n    font-size:3.5rem;\n    \n}",".excel-container {\n\n    display:flex;\n    flex-direction: column;\n    width:800px;\n    margin:2rem auto;\n    gap:.5rem;\n\n    h2 {\n        text-align: center;\n        padding:2rem 0;\n    }\n\n    #btn-excel {\n        width:150px;\n        margin:1rem auto;\n        text-align: center;\n    }\n}",".sdq-form-container {\n\n    display:flex;\n    flex-direction: column;\n    width:800px;\n    margin:2rem auto;\n    gap:.5rem;\n\n    h2 {\n        text-align: center;\n        padding:2rem 0;\n    }\n\n    .btn-parent {\n        width:150px;\n        margin:1rem auto;\n        text-align: center;\n    }\n}",".aces-test {\n    height:100%;\n    overflow:hidden;\n}\n\n.aces-direction {\n    display:flex;\n    flex-direction: column !important;\n    transform: rotate(270deg) !important;\n    flex-wrap: nowrap;\n    width:100%;\n    img {\n        width:450px;\n    }\n}\n\n* {\n    box-sizing: border-box;\n}\n\n.aces-page-item {\n    max-width:100%;\n    margin-left:0;\n\n\n}\n\n\n.next {\n    width:200px;\n}\n\n.aces-next {\n    max-width: 100%;\n    overflow: hidden; \n\n    p {\n        max-width:1100px;\n    }\n}\n\n\n\n.aces-content-wrapper {\n    width:600px ;\n    flex-direction: column !important;\n  \n}\n\n#root > div.aces-test > div > div.swiper-button-prev\n\n {\n    padding:0px;\n    width:40px !important;\n    height:40px !important;\n}\n\n#root > div.aces-test > div > div.swiper-button-next{ \n    padding:0 !important;\n    width:40px !important;\n    height:40px !important;\n    \n}\n\n\n.swiper-button-next:after, .swiper-button-prev:after {\n    font-size:1rem !important;\n    padding:0;\n    margin:0;\n\n}\n",".wally-emotion {\n    max-width:170px !important;\n\n}\n\n#swiper-wrapper-47465d4421825ce4 > div.swiper-slide.swiper-slide-active > div > img {\n    max-width:450px;\n}\n\n.item-image-wally {\n    text-align:center;\n    margin:4rem auto 0 auto;\n    width:900px;\n    img {\n        width:80%;\n        max-width:600px;\n        margin:1rem;\n    }\n}\n\n.wally-action {\n    max-width:230px !important;\n}\n\n.wally-label {\n    text-align:center;\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    gap:1rem;\n    p {\n        text-align:center;\n        font-weight: 700;\n    }\n}\n\n.wally-form {\n    display:flex;\n    flex-direction: row !important;\n/*     gap:2rem; */\n\n}",".corsi-container {\n    background-color:#333;\n    height:calc(100% - 60px);\n    width:100%;\n    display:flex;\n    justify-content: center;\n    align-items: center;\n\n    .separator {\n        position:absolute;\n        width:100%;\n        height:calc(100% - 60px);\n    }\n\n    .game-box {\n\n        width:1000px;\n        height:100%;\n        display:flex;\n        flex-wrap:wrap;\n        gap:1rem;\n        padding:2rem;\n        padding-top:4rem;\n        .corsi-box {\n            border:1px solid #fff;\n            width:90px;\n            height:90px;\n        }\n\n        .box-1 {\n            margin-left:2rem;\n            margin-top:8rem;\n        }\n\n        .box-2 {\n            margin-left:2rem;\n        }\n\n        .box-3 {\n            margin-left:4rem;\n            margin-top:5rem;\n        }\n        .box-4 {\n            margin-left:5rem;\n            margin-top:7rem;\n        }\n        .box-5 {\n            margin-left:5rem;\n            margin-top:2rem;\n        }\n        .box-6 {\n            margin-left:4rem;\n        }\n        .box-7 {\n            margin-left:4rem;\n            margin-top:-4rem;\n        }\n        \n        .box-8 {\n            margin-left:4rem;\n            margin-top:-2rem;\n        }\n        .box-9 {\n            margin-left:4rem;\n            margin-top:3rem;\n        }\n        .box-10 {\n            margin-left:4rem;\n            margin-top:-6rem;\n        }\n    }\n\n    @media (min-width: 1200px) { \n        .game-box {\n            gap:2.5rem;\n        }\n    }\n\n}\n\n.switch-on {\n    border:1px solid #4897be !important;\n    background-color:#4897be;\n}\n\n.hidden {\n    display:none;\n    visibility:hidden;\n}\n\n.corsi-options {\n    border:1px solid #ccc;\n    align-self:center;\n}\n\n.corsi-start,\n.rotate-container {\n    transform:rotate(270deg);\n}",".table-moments {\n    width:60% !important; \n    margin:0 auto;\n    h2 {\n        padding:2rem 0;\n    }\n}",".hnf-container {\n\n    display:flex;\n    flex-direction:column;\n\n    .hnf-option-container {\n        display:flex;\n        border:1px solid #ccc;\n        justify-content: space-between;\n        border-radius:.5rem;\n        margin:2rem;\n        position:relative !important;\n        \n    }\n    \n    .hnf-box {\n        width:50%;\n        height:200px;\n        border-radius:.5rem;\n        background-color: #fff;\n        z-index:2;\n    }\n    \n    .hnf-button-container {\n        display:flex;\n        justify-content: space-around;\n        border-radius:.5rem;\n\n        .hnf-button {\n            width:400px;\n            height:250px;\n            border-radius:.5rem;\n            border:none;\n            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.4);\n            background-color:#f3f3f7;\n        }\n\n        .hnf-button:active {\n            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n        }\n    }\n\n}\n\n.hnf-heart {\n    background-image:url('/public/images/corazon.png');\n    background-size: contain;\n    background-repeat:no-repeat;\n    background-position: center;\n\n\n} \n\n.hnf-flower {\n    background-image:url('/public/images/flower.png');\n    background-size: contain;\n    background-repeat:no-repeat;\n    background-position: center;\n    width:10px;\n\n}\n\n.hnf-instructions-1 {\n    position:absolute;\n    width:100%;\n    height:600px;\n    z-index:10;\n    background-color:#fff;\n\n    div {\n        h4 {\n            width:80%;\n            margin:2rem auto;\n            text-align: center;\n        }\n    }\n}\n\n.plusOverlay {\n    background-color: #fff;\n    width:300px !important;\n}\n\n\n.first-example {\n    background-image:url('/public/images/corazon-1.png');\n    background-size: contain;\n    background-repeat:no-repeat;\n    background-position: center;\n    width:400px;\n    height:250px;\n}\n\n.second-example {\n    background-image:url('/public/images/corazon-2.png');\n    background-size: contain;\n    background-repeat:no-repeat;\n    background-position: center;\n    width:400px;\n    height:250px;\n}\n\n.hnf-example-container {\n    display:flex;\n    justify-content: space-around;\n    margin-top:3rem;\n}\n\n.hidden-container {\n    z-index:0;\n    display:none;\n    visibility: hidden;\n}\n\n\n#hnf-wall {\n    border:2px solid red;\n    z-index:-1;\n    background-color:#ddd;\n}\n\n\n.overlay {\n    z-index: 2; \n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.container-hnf {\n    height:100vh;\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n}",".play-button {\n    cursor:pointer;\n}\n\n.active-option {\n    color:#fff;\n    background-color:#20c997;\n}\n.go-btn {\n    display:flex;\n    width: 90%; \n    margin: 0 auto;\n    margin-top:14rem;\n    justify-content:center;\n}","\n// Mediaqueries\n\n\n// Large devices (desktops, 992px and up)\n@media (max-height: 650px) { \n    p {\n        font-size:.95rem;\n    }\n\n    h2 {\n        font-size:1.5rem !important;\n    }\n\n    .main-description {\n        font-size: 1.2rem;\n        padding:0 !important;\n    }\n    #root .aside-menu a {\n  \n        padding:0;\n\n    }\n\n    .instruments-list {\n        div {\n            padding: 0;\n        }\n    }\n\n    .page-item {\n        img {\n            max-width:500px;\n        }\n    }\n\n    //calculo\n\n    \n    .containerBox {\n        height:300px !important;\n        width:600px !important;\n    }\n\n\n    .containerBox > .landing-area > .piece-inside,\n    .containerBox > .landing-area > .piece-inside-countable,\n    .containerBox > .pieces-container > .piece  {\n        width:50px !important;\n        height:50px !important;\n    }\n\n\n    //Fono\n\n    .play-button {\n        width:50px;\n        height:50px;\n        img {\n            width:50px !important;\n        }\n    }\n\n    .go-btn {\n        margin-top:5.5rem;\n        margin-left:-12rem;\n    }\n\n    .title-answers {\n        font-size:1rem;\n    }\n\n    //Wally\n\n    .item-image-wally {\n        img {\n            max-width: 420px;\n        }\n       \n    }\n    \n    //aces\n    .aces-page-item {\n        \n        img {\n            width:400px;\n        }\n        \n    }\n    \n    .column-instruction {\n        \n        .instruction {\n            height:350px;\n            width:350px;\n            margin:-3rem;\n            \n            p {\n                font-size: 1rem;\n            }\n        }\n    }\n    \n    //Corsi\n    \n    .corsi-container {\n        padding-top:2rem;\n    }\n    \n    .corsi-container .game-box {\n        padding:1rem;\n        padding-top:0;\n        gap:2.5rem;\n    }\n    \n    //hnf\n    \n    .hnf-button-container {\n        \n        .hnf-button {\n            width:350px !important;\n            height:200px !important;\n            border-radius:.5rem;\n            border:none;\n            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.4);\n            background-color:#f3f3f7;\n        }\n        \n    }\n\n    //Wally2\n\n    .item-image-wally2 {\n        img {\n            max-width: 420px;\n        }\n        \n    }\n    \n    \n}",".thirdStick {\n    background-image: url('/public/images/stick.png');\n    background-position: bottom;\n    background-repeat: no-repeat;\n    background-size: 30px 300px;\n}\n\n.secondStick {\n    background-image: url('/public/images/stick.png');\n    background-position: bottom;\n    background-repeat: no-repeat;\n    background-size: 30px 210px;\n}\n\n.firstStick {\n    background-image: url('/public/images/stick.png');\n    background-position: bottom;\n    background-repeat: no-repeat;\n    background-size: 30px 120px;\n}\n\n\n",".esc-image {\n    position: absolute; \n    left: 0; \n    right: 0; \n    margin-left: auto; \n    margin-right: auto; \n    width: 600px; /* Need a specific value to work */\n}\n\n\n\n.esc-emotion {\n    width:350px;\n    height:200px;\n    box-sizing: border-box;\n}\n\n.esc-test {\n    display: flex;\n    flex-direction: column;\n}\n.esc-test:hover {\n    outline:4px solid #3aafb9;;\n}\n\n.esc-test:active {\n    outline:4px solid #3aafb9;;\n}\n\n.esc-slide {\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n}\n\n\n.esc-form {\n    display:flex;\n    flex-direction:row;\n    flex-wrap:wrap;\n    gap:.5rem;\n    align-items:center;\n    justify-content:flex-start;\n}\n\n\n@media (min-width: 1200px) { \n    .esc-emotion {\n            width:500px;\n            height:250px;\n            box-sizing: border-box;\n    }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@800;900&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,400;1,500;1,700;1,900&display=swap');\n@import 'index';\n@import 'navbar';\n@import 'aside';\n@import 'login';\n@import 'normalize';\n@import 'home';\n@import 'students';\n@import 'instruments-list';\n@import 'items';\n@import 'book';\n@import 'instruction';\n@import 'excel';\n@import 'sdq';\n@import 'aces';\n@import 'wally';\n@import 'corsi';\n@import 'moments';\n@import 'hnf';\n@import 'fonologico';\n@import 'responsiveA7';\n@import 'london-tower';\n@import 'esc';\n@import 'eml';\n@import 'stroopnum';\n\nhtml {\n    background-color: #fff;\n}\n\n.first-instrument {\n    height:100%;\n}\nbody, html {\n    -webkit-touch-callout: none; /* Safari */\n    -webkit-user-select: none; /* Chrome */     \n       -moz-user-select: none; /* Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n            user-select: none; \n}\n\nimg {\n    pointer-events: none;\n}\n\n#root {\n    background-color: #fff;\n    height:100vh;\n}\n\n.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before {\n    background-color: #fff !important;\n}\n\n.swiper {\n    height:100%;\n    overflow:hidden;\n}\n.swiper-button-disabled {\n    visibility: hidden !important;\n}\n.swiper-button-next,\n.swiper-button-prev {\n    background-color:#3aafb9;\n    color:#fff !important;\n    width:45px !important;\n    margin-top:30vh !important; \n    padding:1rem;\n    border-radius: 2rem;\n    -webkit-border-radius: 2rem;\n    -moz-border-radius: 2rem;\n    -ms-border-radius: 2rem;\n    -o-border-radius: 2rem;\n    box-shadow: 0px 5px 5px rgba(2, 2, 0, 0.35);\n}\n\n.swiper-button-next:active,\n.swiper-button-prev:active {\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n}\n\n.swiper-button-next {\n    margin-right:3rem;\n}\n\n.swiper-button-prev {\n    margin-left:3rem;\n}\n\n.swiper-scrollbar-drag {\n    background-color: #ff6838 !important;\n\n}\n\n/* Se supone esto ayuda para no recargar la pagina en celulares desplazando el dedo */\n\nbody\n{\n  overscroll-behavior-y: contain !important;\n}\n\n.button {\n    width:120px;\n    margin: 0 auto;\n}\n\n\n\n\n\n\n.game-title {\n    text-align: center;\n    margin-top:.7rem;\n    color:#444;\n}\n\n\n.containerBox {\n    margin:2rem;\n\n    width:800px;\n    height:500px;\n    margin:2rem auto;\n    display:flex;\n    justify-content: center;\n\n        .pieces-container {\n            width:50%;\n\n            display: flex;\n            flex-wrap: wrap;\n            align-items: flex-start;\n            align-content: flex-start;\n            gap: 0.5rem;\n            padding:.2rem;\n            .piece {\n                width: 70px;\n                height: 70px;\n                background-color: #FF5656;\n                \n                border-radius: 50%;\n                -webkit-border-radius: 50%;\n                -moz-border-radius: 50%;\n                -ms-border-radius: 50%;\n                -o-border-radius: 50%;\n                box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);\n\n\n            }\n\n\n        }\n\n\n    .landing-area {\n        width:50%;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: flex-start;\n        align-content: flex-start;\n        gap: 0.5rem;\n        padding:.2rem;\n        box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.6);\n        border-radius:.5rem ;\n        -webkit-border-radius:.5rem ;\n        -moz-border-radius:.5rem ;\n        -ms-border-radius:.5rem ;\n        -o-border-radius:.5rem ;\n\n        .piece-inside, .piece-inside-countable{\n            width: 70px;\n            height: 70px;\n            background-color: #FF5656;\n\n            border-radius: 50%;\n            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n            -webkit-border-radius: 50%;\n            -moz-border-radius: 50%;\n            -ms-border-radius: 50%;\n            -o-border-radius: 50%;\n        }\n\n        \n\n    }\n\n}\n\n.restart-button {\n    display: block;\n    width:100px;\n    height:40px;\n    color:#fff;\n    background-color: #3aafb9;\n    text-align: center;\n    margin:0 auto ;\n    border-radius: .5rem;\n    -webkit-border-radius: .5rem;\n    -moz-border-radius: .5rem;\n    -ms-border-radius: .5rem;\n    -o-border-radius: .5rem;\n    border:none;\n    outline: none !important;\n}\n\n.quantification-value {\n    width:70px;\n    padding:.5rem !important;\n}\n\n.swiper-scrollbar {\n    height:1rem !important;\n}\n\n.swiper-wrapper {\n    height:calc(100vh - 120px) !important;\n}\n\n.btn-visibility {\n    width:40px;\n    height:40px;\n    outline: none;\n    border:none;\n    display:inline;\n    position:absolute;\n    top:-10px;\n    right:10px;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    box-shadow: 0px 3px 3px rgba(2, 2, 0, 0.25);\n    background-color: inherit;\n    color:#3aafb9;\n}\n\n.image-instruction-container {\n    width:100%;\n    display:flex;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    position:relative;\n}\n\n.main-content-wrapper {\n    display:flex;\n    flex-direction: row-reverse;\n    align-items:center;\n    align-content:center;\n    gap:2rem;\n    img {\n        max-width:100%;\n        max-height:500px;\n    }\n\n    form {\n        width:50%;\n    }\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n\n\n.quantification-counter {\n    display:flex;\n    align-items:baseline;\n    align-content: center;\n    justify-content: space-between;\n    width:400px;\n    gap:.5rem;\n\n    \n\n    .form-check-label {\n        padding:0;\n        margin:0 1rem;\n        width:70px !important;\n    }\n}\n\n\n.japi-container {\n    background-image: url('/public/images/japi-background.jpg');\n    background-size:cover;\n    background-repeat:no-repeat;\n    width: 100%;\n    padding:2rem;\n    display: flex;\n    align-items: center;\n    height:100%;\n    gap:10px;\n    flex-direction: column;\n}\n\n\n.japi-container-center {\n    background-image: url('/public/images/japi-background.jpg');\n    background-size:cover;\n    background-repeat:no-repeat;\n    width: 100%;\n    padding:2rem;\n    display: flex;\n    align-items: center;\n    height:100%;\n    gap:10px;\n    flex-direction: column;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
